// Supported languages
export type Language = 'en' | 'fr' | 'es' | 'ar' | 'jp';

export const SUPPORTED_LANGUAGES: Language[] = ['en', 'fr', 'es', 'ar', 'jp'];

export const DEFAULT_LANGUAGE: Language = 'en';

// Translation dictionary type
type TranslationDict = {
  [key: string]: {
    en: string;
    fr: string;
    es: string;
    ar: string;
    jp: string;
  };
};

// All translations - from microcopy JSON + additional strings
export const translations: TranslationDict = {
  // From microcopy JSON
  fantasyTitle: {
    en: "Fantasy Pick'em",
    fr: "Fantasy Pick'em",
    es: "Fantasy Pick'em",
    ar: "اختيار فانتازيا",
    jp: "ファンタジー・ピックエム"
  },
  card: {
    en: "Card",
    fr: "Carte",
    es: "Carta",
    ar: "بطاقة",
    jp: "カード"
  },
  round: {
    en: "Round",
    fr: "Manche",
    es: "Ronda",
    ar: "جولة",
    jp: "ラウンド"
  },
  of: {
    en: "of",
    fr: "de",
    es: "de",
    ar: "من",
    jp: "の"
  },
  jan: {
    en: "Jan",
    fr: "Jan",
    es: "Ene",
    ar: "يناير",
    jp: "1月"
  },
  feb: {
    en: "Feb",
    fr: "Fév",
    es: "Feb",
    ar: "فبراير",
    jp: "2月"
  },
  mar: {
    en: "Mar",
    fr: "Mar",
    es: "Mar",
    ar: "مارس",
    jp: "3月"
  },
  apr: {
    en: "Apr",
    fr: "Avr",
    es: "Abr",
    ar: "أبريل",
    jp: "4月"
  },
  may: {
    en: "May",
    fr: "Mai",
    es: "May",
    ar: "مايو",
    jp: "5月"
  },
  jun: {
    en: "Jun",
    fr: "Jui",
    es: "Jun",
    ar: "يونيو",
    jp: "6月"
  },
  jul: {
    en: "Jul",
    fr: "Jui",
    es: "Jul",
    ar: "يوليو",
    jp: "7月"
  },
  aug: {
    en: "Aug",
    fr: "Aoû",
    es: "Ago",
    ar: "أغسطس",
    jp: "8月"
  },
  sep: {
    en: "Sep",
    fr: "Sep",
    es: "Sep",
    ar: "سبتمبر",
    jp: "9月"
  },
  oct: {
    en: "Oct",
    fr: "Oct",
    es: "Oct",
    ar: "أكتوبر",
    jp: "10月"
  },
  nov: {
    en: "Nov",
    fr: "Nov",
    es: "Nov",
    ar: "نوفمبر",
    jp: "11月"
  },
  dec: {
    en: "Dec",
    fr: "Déc",
    es: "Dic",
    ar: "ديسمبر",
    jp: "12月"
  },
  totalPoints: {
    en: "Total points",
    fr: "Points totaux",
    es: "Puntos totales",
    ar: "مجموع النقاط",
    jp: "合計ポイント"
  },
  globalRanking: {
    en: "Global ranking",
    fr: "Classement mondial",
    es: "Clasificación global",
    ar: "الترتيب العالمي",
    jp: "グローバルランキング"
  },
  currentRound: {
    en: "Current round",
    fr: "Manche actuelle",
    es: "Ronda actual",
    ar: "الجولة الحالية",
    jp: "現在のラウンド"
  },
  roundStreak: {
    en: "Round streak",
    fr: "Série de manches",
    es: "Racha de rondas",
    ar: "سلسلة الجولات",
    jp: "ラウンド連勝"
  },
  yourPicks: {
    en: "Your picks",
    fr: "Vos choix",
    es: "Tus selecciones",
    ar: "اختياراتك",
    jp: "あなたの予想"
  },
  leagues: {
    en: "Leagues",
    fr: "Ligues",
    es: "Ligas",
    ar: "الدوريات",
    jp: "リーグ"
  },
  rankings: {
    en: "Rankings",
    fr: "Classements",
    es: "Clasificaciones",
    ar: "التراتيب",
    jp: "ランキング"
  },
  winners: {
    en: "Winners",
    fr: "Gagnants",
    es: "Ganadores",
    ar: "الفائزون",
    jp: "勝者"
  },
  prizes: {
    en: "Prizes",
    fr: "Prix",
    es: "Premios",
    ar: "جوائز",
    jp: "賞金"
  },
  terms: {
    en: "Terms",
    fr: "Conditions",
    es: "Términos",
    ar: "الشروط والأحكام",
    jp: "利用規約"
  },
  howPlay: {
    en: "How to play",
    fr: "Comment jouer",
    es: "Cómo jugar",
    ar: "كيفية اللعب",
    jp: "遊び方"
  },
  globalLeaderboard: {
    en: "Global leaderboard",
    fr: "Classement mondial",
    es: "Clasificación global",
    ar: "لوحة الصدارة العالمية",
    jp: "グローバルリーダーボード"
  },
  you: {
    en: "You",
    fr: "Vous",
    es: "Tú",
    ar: "أنت",
    jp: "あなた"
  },
  privateLeague: {
    en: "Private league",
    fr: "Ligue privée",
    es: "Liga privada",
    ar: "دوري خاص",
    jp: "プライベートリーグ"
  },
  viewYourLeaderboards: {
    en: "View all your leagues",
    fr: "Voir toutes vos ligues",
    es: "Ver todas tus ligas",
    ar: "عرض جميع دورياتك",
    jp: "すべてのリーグを見る"
  },
  koFrenzyHeading: {
    en: "KO Frenzy",
    fr: "KO Frenzy",
    es: "KO Frenzy",
    ar: "جنون الضربة القاضية",
    jp: "KO フレンジー"
  },
  koFrenzyBody: {
    en: "Every knockout on this card will earn you double points – whether you picked it or not.",
    fr: "Chaque KO sur cette carte vous rapportera des points doublés — que vous l'ayez choisi ou non.",
    es: "Cada nocaut en esta cartelera te otorgará el doble de puntos, lo hayas elegido o no.",
    ar: "كل ضربة قاضية في هذه البطاقة ستمنحك ضعف النقاط — سواء اخترتها أم لا.",
    jp: "このカードで生まれるすべてのノックアウトは、選択していなくてもポイントが2倍になります。"
  },
  koFrenzyTip: {
    en: "Tip: Best saved for cards stacked with heavy hitters, or when you're expecting early finishes across the night.",
    fr: "Astuce : À privilégier pour les cartes riches en gros frappeurs, ou lorsque vous attendez des fins de combat rapides tout au long de la soirée.",
    es: "Consejo: Es mejor guardarla para carteleras cargadas de pegadores, o cuando se esperan finales tempranos a lo largo de la noche.",
    ar: "نصيحة: من الأفضل حفظها للبطاقات المليئة بالضاربين الأقوياء، أو عندما تتوقع نهايات مبكرة طوال الأمسية.",
    jp: "ヒント：強打者が揃ったカードや、一晩を通して早い決着が予想される場合に取っておくのが最適です。"
  },
  koFrenzyDisclaimer: {
    en: "You can only use KO Frenzy once per season. Once played, it's gone.",
    fr: "Vous ne pouvez utiliser KO Frenzy qu'une seule fois par saison. Une fois joué, il disparaît.",
    es: "Solo puedes usar KO Frenzy una vez por temporada. Una vez activado, se pierde.",
    ar: "يمكنك استخدام KO Frenzy مرة واحدة فقط في الموسم. بمجرد استخدامه، ينتهي.",
    jp: "KO Frenzyはシーズンに1回しか使用できません。一度使うと、もう使えなくなります。"
  },
  championBeltHeading: {
    en: "Champion Belt",
    fr: "Ceinture de Champion",
    es: "Cinturón de Campeón",
    ar: "حزام البطل",
    jp: "チャンピオンベルト"
  },
  championBeltBody: {
    en: "Boost your Champion pick to 4x points, instead of the usual 2x.",
    fr: "Boostez votre choix de Champion pour gagner 4× points au lieu des 2× habituels.",
    es: "Impulsa tu elección de Campeón a 4× puntos, en lugar de los 2× habituales.",
    ar: "عزّز اختيارك للبطل لتحصل على 4 أضعاف النقاط بدلًا من الضعف المعتاد.",
    jp: "通常の2倍ではなく、チャンピオンの選択を4倍ポイントにブーストできます。"
  },
  championBeltTip: {
    en: "Tip: Best used on title fights or headline events where you're confident your pick will win — but choose carefully, a loss here could cost you big.",
    fr: "Astuce : À utiliser de préférence sur des combats pour le titre ou des événements principaux lorsque vous êtes sûr(e) de votre choix — mais choisissez avec soin : une défaite ici peut coûter cher.",
    es: "Consejo: Es mejor usarlo en peleas por el título o eventos estelares cuando confías en que tu elección ganará — pero elige con cuidado, una derrota aquí puede salir muy cara.",
    ar: "نصيحة: يُفضَّل استخدامه في نزالات اللقب أو الأحداث الرئيسية عندما تكون واثقًا من فوز اختيارك — لكن اختر بحذر، فالهزيمة هنا قد تكلفك كثيرًا.",
    jp: "ヒント：タイトルマッチやメインイベントなど、勝利に自信がある場合に使うのが最適です。ただし慎重に選びましょう。ここでの敗北は大きな痛手になります。"
  },
  championBeltDisclaimer: {
    en: "You can only use Ring Champion Belt once per season. Once played, it's gone.",
    fr: "Vous ne pouvez utiliser la ceinture Ring Champion qu'une seule fois par saison. Une fois utilisée, elle disparaît.",
    es: "Solo puedes usar el cinturón Ring Champion una vez por temporada. Una vez usado, se pierde.",
    ar: "يمكنك استخدام حزام Ring Champion مرة واحدة فقط في الموسم. بمجرد استخدامه، ينتهي.",
    jp: "Ring Champion Beltはシーズンに1回しか使用できません。一度使うと、もう使えなくなります。"
  },
  lateStopsHeading: {
    en: "Go the Distance",
    fr: "Aller la distance",
    es: "Ir la distancia",
    ar: "الذهاب للمسافة",
    jp: "ゴー・ザ・ディスタンス"
  },
  lateStopsBody: {
    en: "Activate this chip and any fight that goes to judges' scorecards and ends by a decision (i.e. no knockout or stoppage) scores double points, regardless of your pick.",
    fr: "Activez cette puce et tout combat qui va aux cartes de pointage des juges et se termine par une décision (c'est-à-dire pas de KO ou d'arrêt) rapporte le double de points, quel que soit votre choix.",
    es: "Activa esta ficha y cualquier pelea que llegue a las tarjetas de puntuación de los jueces y termine por decisión (es decir, sin nocaut ni detención) otorga el doble de puntos, independientemente de tu elección.",
    ar: "فعّل هذه الرقاقة وأي نزال يذهب إلى بطاقات تسجيل الحكام وينتهي بقرار (أي بدون ضربة قاضية أو توقف) يمنح نقاطًا مضاعفة، بغض النظر عن اختيارك.",
    jp: "このチップを有効にすると、ジャッジのスコアカードに委ねられ、判定（ノックアウトやストップなし）で終了する試合はすべて、あなたの予想に関係なくポイントが2倍になります。"
  },
  lateStopsTip: {
    en: "Tip: Best used on evenly matched fighters, elite defensively sound boxers, or bouts where neither fighter is known for early knockouts.",
    fr: "Astuce : À utiliser de préférence sur des combattants de niveau égal, des boxeurs d'élite défensivement solides, ou des combats où aucun des deux combattants n'est connu pour ses KO précoces.",
    es: "Consejo: Es mejor usarlo en luchadores parejos, boxeadores de élite defensivamente sólidos, o peleas donde ninguno de los luchadores es conocido por nocauts tempranos.",
    ar: "نصيحة: يُفضَّل استخدامها على المقاتلين المتكافئين، أو الملاكمين المتميزين دفاعيًا، أو النزالات التي لا يُعرف فيها أي من المقاتلين بالضربات القاضية المبكرة.",
    jp: "ヒント：実力が拮抗したファイター、守備に優れたエリートボクサー、または早いノックアウトで知られていないファイター同士の試合に最適です。"
  },
  lateStopsDisclaimer: {
    en: "You can only use Go the Distance once per season. Once played, it's gone.",
    fr: "Vous ne pouvez utiliser Aller la distance qu'une seule fois par saison. Une fois joué, c'est terminé.",
    es: "Solo puedes usar Ir la distancia una vez por temporada. Una vez activado, se pierde.",
    ar: "يمكنك استخدام الذهاب للمسافة مرة واحدة فقط في الموسم. بمجرد استخدامه، ينتهي.",
    jp: "ゴー・ザ・ディスタンスはシーズンに1回しか使用できません。一度使うと、もう使えなくなります。"
  },
  playChip: {
    en: "Play chip",
    fr: "Jeton de jeu",
    es: "Ficha de juego",
    ar: "رقاقة اللعب",
    jp: "プレイチップ"
  },
  vs: {
    en: "VS",
    fr: "VS",
    es: "VS",
    ar: "ضد",
    jp: "VS"
  },
  decision: {
    en: "Decision",
    fr: "Décision",
    es: "Decisión",
    ar: "قرار",
    jp: "判定"
  },
  pick: {
    en: "Pick",
    fr: "Choix",
    es: "Selección",
    ar: "اختر",
    jp: "予想"
  },
  leftDeadline: {
    en: "Left until deadline",
    fr: "Reste avant la date limite",
    es: "Restante hasta la fecha límite",
    ar: "المتبقي حتى الموعد النهائي",
    jp: "期限までの残り時間"
  },
  nextCard: {
    en: "Next card",
    fr: "Prochaine carte",
    es: "Próxima carta",
    ar: "البطاقة التالية",
    jp: "次のカード"
  },
  autoPick: {
    en: "Auto pick",
    fr: "Choix automatique",
    es: "Selección automática",
    ar: "اختيار تلقائي",
    jp: "自動予想"
  },
  reset: {
    en: "Reset",
    fr: "Réinitialiser",
    es: "Restablecer",
    ar: "إعادة ضبط",
    jp: "リセット"
  },
  results: {
    en: "Results",
    fr: "Résultats",
    es: "Resultados",
    ar: "النتائج",
    jp: "結果"
  },
  pointsScored: {
    en: "Points scored",
    fr: "Points marqués",
    es: "Puntos anotados",
    ar: "النقاط المسجلة",
    jp: "獲得ポイント"
  },
  viewLeaderboards: {
    en: "View leaderboard",
    fr: "Voir le classement",
    es: "Ver clasificación",
    ar: "عرض لوحة الصدارة",
    jp: "リーダーボードを見る"
  },
  average: {
    en: "Average",
    fr: "Moyenne",
    es: "Promedio",
    ar: "المتوسط",
    jp: "平均"
  },
  highest: {
    en: "Highest",
    fr: "Le plus haut",
    es: "Más alto",
    ar: "الأعلى",
    jp: "最高"
  },
  fight: {
    en: "Fight",
    fr: "Combat",
    es: "Pelea",
    ar: "قتال",
    jp: "対戦"
  },
  hideResults: {
    en: "Hide results",
    fr: "Masquer les résultats",
    es: "Ocultar resultados",
    ar: "إخفاء النتائج",
    jp: "結果を非表示"
  },
  previousPick: {
    en: "Previous pick",
    fr: "Choix précédent",
    es: "Selección anterior",
    ar: "الاختيار السابق",
    jp: "前回の予想"
  },
  play: {
    en: "Play",
    fr: "Jouer",
    es: "Jugar",
    ar: "العب",
    jp: "プレイ"
  },
  byWayOf: {
    en: "By way of",
    fr: "Par",
    es: "Por medio de",
    ar: "عن طريق",
    jp: "決着方法"
  },
  winner: {
    en: "Winner",
    fr: "Vainqueur",
    es: "Ganador",
    ar: "الفائز",
    jp: "勝者"
  },
  taleTape: {
    en: "Tale of the tape",
    fr: "Fiche du combat",
    es: "Historial de datos",
    ar: "سجل الأرقام",
    jp: "対戦データ"
  },
  communityPicks: {
    en: "Community picks",
    fr: "Choix de la communauté",
    es: "Selecciones de la comunidad",
    ar: "اختيارات المجتمع",
    jp: "コミュニティの予想"
  },
  record: {
    en: "Record",
    fr: "Fiche",
    es: "Récord",
    ar: "السجل",
    jp: "戦绩"
  },
  lastFights: {
    en: "Last 5 fights",
    fr: "5 derniers combats",
    es: "Últimas 5 peleas",
    ar: "آخر 5 نزالات",
    jp: "直近5試合"
  },
  nationality: {
    en: "Nationality",
    fr: "Nationalité",
    es: "Nacionalidad",
    ar: "الجنسية",
    jp: "国籍"
  },
  age: {
    en: "Age",
    fr: "Âge",
    es: "Edad",
    ar: "العمر",
    jp: "年齢"
  },
  stance: {
    en: "Stance",
    fr: "Position",
    es: "Postura",
    ar: "الوضعية",
    jp: "スタンス"
  },
  players: {
    en: "players",
    fr: "joueurs",
    es: "jugadores",
    ar: "اللاعبون",
    jp: "プレイヤー"
  },
  koTko: {
    en: "KO/TKO",
    fr: "KO/TKO",
    es: "KO/TKO",
    ar: "ضربة قاضية/تقنية",
    jp: "KO/TKO"
  },
  readyChallengeHeading: {
    en: "Ready for your next challenge?",
    fr: "Prêt pour votre prochain défi ?",
    es: "¿Listo para tu próximo desafío?",
    ar: "هل أنت مستعد لتحديك القادم؟",
    jp: "次のチャレンジの準備はできましたか？"
  },
  readyChallengeBody: {
    en: "Enter a league code from a friend to jump straight in, or start fresh and create your own league from scratch.",
    fr: "Entrez un code de ligue d'un ami pour rejoindre directement, ou recommencez à zéro et créez votre propre ligue.",
    es: "Ingresa un código de liga de un amigo para unirte directamente, o empieza de cero y crea tu propia liga",
    ar: "أدخل رمز دوري من صديق للانضمام إليه مباشرة، أو ابدأ من جديد وأنشئ دوريك الخاص من الصفر.",
    jp: "友達からのリーグコードを入力してすぐに参加するか、最初から新しいリーグを作成してください。"
  },
  readyChallengeCta1: {
    en: "Join a league",
    fr: "Rejoindre une ligue",
    es: "Unirse a una liga",
    ar: "انضم إلى دوري",
    jp: "リーグに参加"
  },
  readyChallengeCta2: {
    en: "Create a league",
    fr: "Créer une ligue",
    es: "Crear una liga",
    ar: "أنشئ دوريًا",
    jp: "リーグを作成"
  },
  statsSeason: {
    en: "Statistics across the season",
    fr: "Statistiques de la saison",
    es: "Estadísticas de la temporada",
    ar: "إحصائيات الموسم",
    jp: "シーズン全体の統計"
  },
  undisputedChampionship: {
    en: "Undisputed championship",
    fr: "Championnat incontesté",
    es: "Campeonato indiscutible",
    ar: "بطولة بلا منازع",
    jp: "文句なしのチャンピオンシップ"
  },
  requestJoin: {
    en: "Enter PIN to Join",
    fr: "Demande de rejoindre",
    es: "Solicitud para unirse",
    ar: "طلب الانضمام",
    jp: "参加リクエスト"
  },

  // Additional translations not in the microcopy JSON
  noPickMade: {
    en: "No pick made",
    fr: "Aucun choix",
    es: "Sin selección",
    ar: "لا يوجد اختيار",
    jp: "選択なし"
  },
  noPredictionMade: {
    en: "No prediction made",
    fr: "Aucune prédiction",
    es: "Sin predicción",
    ar: "لا يوجد توقع",
    jp: "予測なし"
  },
  pts: {
    en: "pts",
    fr: "pts",
    es: "pts",
    ar: "نقاط",
    jp: "pts"
  },
  postponed: {
    en: "Postponed",
    fr: "Reporté",
    es: "Pospuesto",
    ar: "مؤجل",
    jp: "延期"
  },
  done: {
    en: "Done",
    fr: "Terminé",
    es: "Listo",
    ar: "تم",
    jp: "完了"
  },
  live: {
    en: "Live",
    fr: "En direct",
    es: "En vivo",
    ar: "مباشر",
    jp: "ライブ"
  },
  completed: {
    en: "Completed",
    fr: "Terminé",
    es: "Completado",
    ar: "مكتمل",
    jp: "完了"
  },
  viewResultCard: {
    en: "View result card",
    fr: "Voir la carte des résultats",
    es: "Ver tarjeta de resultados",
    ar: "عرض بطاقة النتائج",
    jp: "結果カードを表示"
  },
  pickSaved: {
    en: "Pick saved",
    fr: "Choix enregistré",
    es: "Selección guardada",
    ar: "تم حفظ الاختيار",
    jp: "予想を保存しました"
  },
  active: {
    en: "Active",
    fr: "Actif",
    es: "Activo",
    ar: "نشط",
    jp: "アクティブ"
  },
  inactive: {
    en: "Inactive",
    fr: "Inactif",
    es: "Inactivo",
    ar: "غير نشط",
    jp: "非アクティブ"
  },
  playedIn: {
    en: "Played in C",
    fr: "Joué en C",
    es: "Jugado en C",
    ar: "لعب في C",
    jp: "C で使用済み"
  },
  nextPick: {
    en: "Next pick",
    fr: "Choix suivant",
    es: "Siguiente selección",
    ar: "الاختيار التالي",
    jp: "次の予想"
  },
  roundPoints: {
    en: "Round points",
    fr: "Points de manche",
    es: "Puntos de ronda",
    ar: "نقاط الجولة",
    jp: "ラウンドポイント"
  },
  publicLeague: {
    en: "Public League",
    fr: "Ligue publique",
    es: "Liga pública",
    ar: "دوري عام",
    jp: "パブリックリーグ"
  },
  yourLeagues: {
    en: "Your leagues",
    fr: "Vos ligues",
    es: "Tus ligas",
    ar: "دورياتك",
    jp: "あなたのリーグ"
  },
  allLeagues: {
    en: "All leagues",
    fr: "Toutes les ligues",
    es: "Todas las ligas",
    ar: "جميع الدوريات",
    jp: "すべてのリーグ"
  },
  join: {
    en: "Join",
    fr: "Rejoindre",
    es: "Unirse",
    ar: "انضم",
    jp: "参加"
  },
  create: {
    en: "Create",
    fr: "Créer",
    es: "Crear",
    ar: "إنشاء",
    jp: "作成"
  },
  createNewLeague: {
    en: "Create a new league",
    fr: "Créer une nouvelle ligue",
    es: "Crear una nueva liga",
    ar: "إنشاء دوري جديد",
    jp: "新しいリーグを作成"
  },
  joinLeague: {
    en: "Join a league",
    fr: "Rejoindre une ligue",
    es: "Unirse a una liga",
    ar: "انضم إلى دوري",
    jp: "リーグに参加"
  },
  inviteFriends: {
    en: "Invite friends",
    fr: "Inviter des amis",
    es: "Invitar amigos",
    ar: "دعوة الأصدقاء",
    jp: "友達を招待"
  },
  leagueName: {
    en: "League name",
    fr: "Nom de la ligue",
    es: "Nombre de la liga",
    ar: "اسم الدوري",
    jp: "リーグ名"
  },
  members: {
    en: "Members",
    fr: "Membres",
    es: "Miembros",
    ar: "الأعضاء",
    jp: "メンバー"
  },
  yourRank: {
    en: "Your Rank",
    fr: "Votre rang",
    es: "Tu rango",
    ar: "ترتيبك",
    jp: "あなたの順位"
  },
  season: {
    en: "Season",
    fr: "Saison",
    es: "Temporada",
    ar: "الموسم",
    jp: "シーズン"
  },
  findLeague: {
    en: "Find a league",
    fr: "Trouver une ligue",
    es: "Buscar una liga",
    ar: "البحث عن دوري",
    jp: "リーグを検索"
  },
  noLeaguesYet: {
    en: "No leagues yet",
    fr: "Pas encore de ligues",
    es: "Aún no hay ligas",
    ar: "لا توجد دوريات بعد",
    jp: "まだリーグがありません"
  },
  joinALeague: {
    en: "Join a league",
    fr: "Rejoindre une ligue",
    es: "Únete a una liga",
    ar: "انضم إلى دوري",
    jp: "リーグに参加する"
  },
  noWeeksAvailable: {
    en: "No weeks available",
    fr: "Aucune semaine disponible",
    es: "No hay semanas disponibles",
    ar: "لا توجد أسابيع متاحة",
    jp: "利用可能な週がありません"
  },
  noFightsScheduled: {
    en: "No fights scheduled for this card (yet)",
    fr: "Aucun combat prévu pour cette carte (encore)",
    es: "No hay peleas programadas para esta carta (aún)",
    ar: "لا توجد نزالات مجدولة لهذه البطاقة (بعد)",
    jp: "このカードには試合が予定されていません（まだ）"
  },
  checkBackLater: {
    en: "Check back later.",
    fr: "Revenez plus tard.",
    es: "Vuelve más tarde.",
    ar: "تحقق لاحقًا.",
    jp: "後でまた確認してください。"
  },
  loadingPredictions: {
    en: "Loading predictions...",
    fr: "Chargement des prédictions...",
    es: "Cargando predicciones...",
    ar: "جارٍ تحميل التنبؤات...",
    jp: "予想を読み込み中..."
  },

  // League-related translations
  allWeeks: {
    en: "All weeks",
    fr: "Toutes les semaines",
    es: "Todas las semanas",
    ar: "جميع الأسابيع",
    jp: "すべての週"
  },
  weekSelection: {
    en: "Week selection",
    fr: "Sélection de la semaine",
    es: "Selección de semana",
    ar: "اختيار الأسبوع",
    jp: "週の選択"
  },
  chooseAWeek: {
    en: "Choose a week",
    fr: "Choisir une semaine",
    es: "Elige una semana",
    ar: "اختر أسبوعًا",
    jp: "週を選択"
  },
  week: {
    en: "Week",
    fr: "Semaine",
    es: "Semana",
    ar: "أسبوع",
    jp: "週"
  },
  networkError: {
    en: "Network error",
    fr: "Erreur réseau",
    es: "Error de red",
    ar: "خطأ في الشبكة",
    jp: "ネットワークエラー"
  },
  leftLeague: {
    en: "You have left the league",
    fr: "Vous avez quitté la ligue",
    es: "Has abandonado la liga",
    ar: "لقد غادرت الدوري",
    jp: "リーグを退会しました"
  },
  leagueDeleted: {
    en: "League has been deleted",
    fr: "La ligue a été supprimée",
    es: "La liga ha sido eliminada",
    ar: "تم حذف الدوري",
    jp: "リーグが削除されました"
  },
  successfullyJoined: {
    en: "Successfully joined the league!",
    fr: "Vous avez rejoint la ligue avec succès !",
    es: "¡Te has unido a la liga exitosamente!",
    ar: "انضممت إلى الدوري بنجاح!",
    jp: "リーグに参加しました！"
  },
  noMembersYet: {
    en: "No members in this league yet",
    fr: "Pas encore de membres dans cette ligue",
    es: "Aún no hay miembros en esta liga",
    ar: "لا يوجد أعضاء في هذا الدوري بعد",
    jp: "このリーグにはまだメンバーがいません"
  },
  noRankingsForRound: {
    en: "Rankings for this round are not yet available.",
    fr: "Les classements pour cette manche ne sont pas encore disponibles.",
    es: "Las clasificaciones para esta ronda aún no están disponibles.",
    ar: "تصنيفات هذه الجولة غير متاحة بعد.",
    jp: "このラウンドのランキングはまだ利用できません。"
  },
  showingSeasonRankings: {
    en: "Showing season rankings instead.",
    fr: "Affichage du classement de la saison à la place.",
    es: "Mostrando clasificaciones de la temporada en su lugar.",
    ar: "عرض تصنيفات الموسم بدلاً من ذلك.",
    jp: "代わりにシーズンランキングを表示しています。"
  },
  enterLeagueName: {
    en: "Enter league name",
    fr: "Entrez le nom de la ligue",
    es: "Ingresa el nombre de la liga",
    ar: "أدخل اسم الدوري",
    jp: "リーグ名を入力"
  },
  leagueDescriptionOptional: {
    en: "League description (optional)",
    fr: "Description de la ligue (facultatif)",
    es: "Descripción de la liga (opcional)",
    ar: "وصف الدوري (اختياري)",
    jp: "リーグの説明（任意）"
  },
  enterPin: {
    en: "Enter 4-digit PIN",
    fr: "Entrez un code PIN à 4 chiffres",
    es: "Ingresa un PIN de 4 dígitos",
    ar: "أدخل رقم التعريف الشخصي المكون من 4 أرقام",
    jp: "4桁のPINを入力"
  },
  invalidPinCode: {
    en: "Incorrect PIN code",
    fr: "Code PIN incorrect",
    es: "PIN incorrecto",
    ar: "رمز PIN غير صحيح",
    jp: "PINコードが正しくありません"
  },
  searchLeaguesMin: {
    en: "Search leagues (min 3 characters)",
    fr: "Rechercher des ligues (min 3 caractères)",
    es: "Buscar ligas (mín 3 caracteres)",
    ar: "البحث عن الدوريات (3 أحرف على الأقل)",
    jp: "リーグを検索（3文字以上）"
  },
  code: {
    en: "Code",
    fr: "Code",
    es: "Código",
    ar: "الرمز",
    jp: "コード"
  },
  leaveLeague: {
    en: "Leave League",
    fr: "Quitter la ligue",
    es: "Abandonar liga",
    ar: "مغادرة الدوري",
    jp: "リーグを退会"
  },
  leaveLeagueConfirm: {
    en: "Are you sure you want to leave this league?",
    fr: "Êtes-vous sûr de vouloir quitter cette ligue ?",
    es: "¿Estás seguro de que quieres abandonar esta liga?",
    ar: "هل أنت متأكد أنك تريد مغادرة هذا الدوري؟",
    jp: "このリーグを退会してもよろしいですか？"
  },
  leaving: {
    en: "Leaving...",
    fr: "Départ en cours...",
    es: "Saliendo...",
    ar: "جارٍ المغادرة...",
    jp: "退会中..."
  },
  deleteLeague: {
    en: "Delete League",
    fr: "Supprimer la ligue",
    es: "Eliminar liga",
    ar: "حذف الدوري",
    jp: "リーグを削除"
  },
  deleting: {
    en: "Deleting...",
    fr: "Suppression en cours...",
    es: "Eliminando...",
    ar: "جارٍ الحذف...",
    jp: "削除中..."
  },
  inviteYourFriends: {
    en: "Invite your friends",
    fr: "Invitez vos amis",
    es: "Invita a tus amigos",
    ar: "ادعُ أصدقاءك",
    jp: "友達を招待する"
  },

  // General UI translations
  loading: {
    en: "Loading...",
    fr: "Chargement...",
    es: "Cargando...",
    ar: "جارٍ التحميل...",
    jp: "読み込み中..."
  },
  searchPlayer: {
    en: "Search player",
    fr: "Rechercher un joueur",
    es: "Buscar jugador",
    ar: "البحث عن لاعب",
    jp: "プレイヤーを検索"
  },
  location: {
    en: "Location",
    fr: "Lieu",
    es: "Ubicación",
    ar: "الموقع",
    jp: "場所"
  },
  fightCard: {
    en: "Fight Card",
    fr: "Carte de combat",
    es: "Cartelera de pelea",
    ar: "بطاقة النزال",
    jp: "ファイトカード"
  },
  noPicksFound: {
    en: "No picks found for this card",
    fr: "Aucun choix trouvé pour cette carte",
    es: "No se encontraron selecciones para esta carta",
    ar: "لم يتم العثور على اختيارات لهذه البطاقة",
    jp: "このカードの予想が見つかりません"
  },
  pastPredictions: {
    en: "Past Predictions",
    fr: "Prédictions passées",
    es: "Predicciones pasadas",
    ar: "التوقعات السابقة",
    jp: "過去の予想"
  },
  noPastPredictions: {
    en: "No past predictions found",
    fr: "Aucune prédiction passée trouvée",
    es: "No se encontraron predicciones pasadas",
    ar: "لم يتم العثور على توقعات سابقة",
    jp: "過去の予想が見つかりません"
  },

  // Booster translations
  savePicks: {
    en: "Save Picks",
    fr: "Enregistrer les choix",
    es: "Guardar selecciones",
    ar: "حفظ الاختيارات",
    jp: "予想を保存"
  },
  boosterActivated: {
    en: "Booster activated",
    fr: "Booster activé",
    es: "Potenciador activado",
    ar: "تم تفعيل المعزز",
    jp: "ブースターが有効になりました"
  },
  boosterDeactivated: {
    en: "Booster deactivated",
    fr: "Booster désactivé",
    es: "Potenciador desactivado",
    ar: "تم إلغاء تفعيل المعزز",
    jp: "ブースターが無効になりました"
  },
  failedToSavePick: {
    en: "Failed to save pick",
    fr: "Échec de l'enregistrement du choix",
    es: "Error al guardar la selección",
    ar: "فشل في حفظ الاختيار",
    jp: "予想の保存に失敗しました"
  },
  failedToActivateBooster: {
    en: "Failed to activate booster",
    fr: "Échec de l'activation du booster",
    es: "Error al activar el potenciador",
    ar: "فشل في تفعيل المعزز",
    jp: "ブースターの有効化に失敗しました"
  },
  failedToDeactivateBooster: {
    en: "Failed to deactivate booster",
    fr: "Échec de la désactivation du booster",
    es: "Error al desactivar el potenciador",
    ar: "فشل في إلغاء تفعيل المعزز",
    jp: "ブースターの無効化に失敗しました"
  },
  failedToJoinLeague: {
    en: "Failed to join league",
    fr: "Échec de l'adhésion à la ligue",
    es: "Error al unirse a la liga",
    ar: "فشل في الانضمام إلى الدوري",
    jp: "リーグへの参加に失敗しました"
  },

  // Fighter stances
  southpaw: {
    en: "Southpaw",
    fr: "Gaucher",
    es: "Zurdo",
    ar: "أعسر",
    jp: "サウスポー"
  },
  orthodox: {
    en: "Orthodox",
    fr: "Orthodoxe",
    es: "Ortodoxo",
    ar: "تقليدي",
    jp: "オーソドックス"
  },

  // Form fields
  emailAddress: {
    en: "Email address",
    fr: "Adresse e-mail",
    es: "Correo electrónico",
    ar: "البريد الإلكتروني",
    jp: "メールアドレス"
  },
  password: {
    en: "Password",
    fr: "Mot de passe",
    es: "Contraseña",
    ar: "كلمة المرور",
    jp: "パスワード"
  },

  // Home page - How to play cards
  pickYourWinners: {
    en: "Pick your winners",
    fr: "Choisissez vos gagnants",
    es: "Elige a tus ganadores",
    ar: "اختر الفائزين",
    jp: "勝者を予想"
  },
  pickYourWinnersDesc: {
    en: "Pick fighters and earn extra points for guessing the correct round knockout.",
    fr: "Choisissez des combattants et gagnez des points supplémentaires en devinant le bon round du KO.",
    es: "Elige luchadores y gana puntos extra por adivinar el round correcto del nocaut.",
    ar: "اختر المقاتلين واكسب نقاطًا إضافية لتخمين جولة الضربة القاضية الصحيحة.",
    jp: "ファイターを選んで、正確なラウンドのノックアウトを当てると追加ポイントを獲得。"
  },
  climbTheRankings: {
    en: "Climb the rankings",
    fr: "Montez dans le classement",
    es: "Sube en el ranking",
    ar: "تسلق التصنيفات",
    jp: "ランキングを上げる"
  },
  climbTheRankingsDesc: {
    en: "Every round and every card, earn points and climb a global leaderboard.",
    fr: "À chaque round et chaque carte, gagnez des points et montez dans le classement mondial.",
    es: "En cada ronda y cada carta, gana puntos y sube en la clasificación global.",
    ar: "في كل جولة وكل بطاقة، اكسب نقاطًا وتسلق لوحة الصدارة العالمية.",
    jp: "毎ラウンド、毎カードでポイントを獲得し、グローバルリーダーボードを上昇。"
  },
  winBigPrizes: {
    en: "Win big prizes",
    fr: "Gagnez de gros prix",
    es: "Gana grandes premios",
    ar: "اربح جوائز كبيرة",
    jp: "豪華賞品を獲得"
  },
  winBigPrizesDesc: {
    en: "Four rounds, four chances to win across the season.",
    fr: "Quatre rounds, quatre chances de gagner tout au long de la saison.",
    es: "Cuatro rondas, cuatro oportunidades de ganar a lo largo de la temporada.",
    ar: "أربع جولات، أربع فرص للفوز طوال الموسم.",
    jp: "4ラウンド、シーズンを通じて4回の勝利チャンス。"
  },
  competeWithFriends: {
    en: "Compete with friends",
    fr: "Affrontez vos amis",
    es: "Compite con amigos",
    ar: "تنافس مع الأصدقاء",
    jp: "友達と競争"
  },
  competeWithFriendsDesc: {
    en: "Pick against your friends in a private league for the ultimate bragging rights.",
    fr: "Affrontez vos amis dans une ligue privée pour le droit de vous vanter.",
    es: "Compite contra tus amigos en una liga privada por el derecho a presumir.",
    ar: "تنافس ضد أصدقائك في دوري خاص للحصول على حق التفاخر.",
    jp: "プライベートリーグで友達と対決して自慢の権利を手に入れよう。"
  },

  // Ticker tape items
  tickerPrizes: {
    en: "Prizes available for your picks",
    fr: "Des prix disponibles pour vos choix",
    es: "Premios disponibles para tus selecciones",
    ar: "جوائز متاحة لاختياراتك",
    jp: "あなたの予想で賞品を獲得"
  },
  tickerPickWinners: {
    en: "Pick your winners from upcoming fights",
    fr: "Choisissez vos gagnants parmi les prochains combats",
    es: "Elige a tus ganadores de las próximas peleas",
    ar: "اختر الفائزين من النزالات القادمة",
    jp: "今後の試合から勝者を予想"
  },
  tickerFullRounds: {
    en: "Go the full 4 rounds to win the undisputed title",
    fr: "Allez jusqu'au bout des 4 rounds pour remporter le titre incontesté",
    es: "Completa las 4 rondas para ganar el título indiscutible",
    ar: "أكمل 4 جولات للفوز باللقب بلا منازع",
    jp: "4ラウンドを完走して文句なしのタイトルを獲得"
  },

  // Confirm modal
  confirm: {
    en: "Confirm",
    fr: "Confirmer",
    es: "Confirmar",
    ar: "تأكيد",
    jp: "確認"
  },
  cancel: {
    en: "Cancel",
    fr: "Annuler",
    es: "Cancelar",
    ar: "إلغاء",
    jp: "キャンセル"
  },

  // Error messages
  errorLoadingLeagues: {
    en: "Unable to load leagues",
    fr: "Impossible de charger les ligues",
    es: "No se pudieron cargar las ligas",
    ar: "تعذر تحميل الدوريات",
    jp: "リーグを読み込めません"
  },

  // Player/Fighter selection (cycling legacy - now used for boxing)
  searchByName: {
    en: "Search by name",
    fr: "Rechercher par nom",
    es: "Buscar por nombre",
    ar: "البحث بالاسم",
    jp: "名前で検索"
  },
  searchFighter: {
    en: "Search fighter",
    fr: "Rechercher un combattant",
    es: "Buscar luchador",
    ar: "البحث عن مقاتل",
    jp: "ファイターを検索"
  },
  team: {
    en: "Team",
    fr: "Équipe",
    es: "Equipo",
    ar: "فريق",
    jp: "チーム"
  },
  allTeams: {
    en: "All teams",
    fr: "Toutes les équipes",
    es: "Todos los equipos",
    ar: "جميع الفرق",
    jp: "すべてのチーム"
  },
  maxValue: {
    en: "Maximum value (millions)",
    fr: "Valeur maximale (millions)",
    es: "Valor máximo (millones)",
    ar: "القيمة القصوى (بالملايين)",
    jp: "最大価値（百万）"
  },
  noLimit: {
    en: "No limit",
    fr: "Pas de limite",
    es: "Sin límite",
    ar: "بدون حد",
    jp: "制限なし"
  },
  name: {
    en: "Name",
    fr: "Nom",
    es: "Nombre",
    ar: "الاسم",
    jp: "名前"
  },
  page: {
    en: "Page",
    fr: "Page",
    es: "Página",
    ar: "صفحة",
    jp: "ページ"
  },
  ofPages: {
    en: "of",
    fr: "de",
    es: "de",
    ar: "من",
    jp: "/"
  },
  teamLimit: {
    en: "Team limit",
    fr: "Limite d'équipe",
    es: "Límite de equipo",
    ar: "حد الفريق",
    jp: "チーム制限"
  },
  overBudget: {
    en: "Over budget",
    fr: "Dépassement de budget",
    es: "Sobre el presupuesto",
    ar: "تجاوز الميزانية",
    jp: "予算超過"
  },
  chooseFighter: {
    en: "Choose a fighter",
    fr: "Choisissez un combattant",
    es: "Elige un luchador",
    ar: "اختر مقاتلًا",
    jp: "ファイターを選択"
  },
  select: {
    en: "Select",
    fr: "Sélectionner",
    es: "Seleccionar",
    ar: "اختر",
    jp: "選択"
  },
  remove: {
    en: "Remove",
    fr: "Retirer",
    es: "Eliminar",
    ar: "إزالة",
    jp: "削除"
  },

  // Stats labels
  roundRank: {
    en: "Round rank",
    fr: "Classement de manche",
    es: "Clasificación de ronda",
    ar: "ترتيب الجولة",
    jp: "ラウンド順位"
  },
  totalPointsLabel: {
    en: "Total points",
    fr: "Points totaux",
    es: "Puntos totales",
    ar: "مجموع النقاط",
    jp: "合計ポイント"
  },
  totalRank: {
    en: "Total rank",
    fr: "Classement total",
    es: "Clasificación total",
    ar: "الترتيب الإجمالي",
    jp: "総合順位"
  },

  // Match prediction strings (soccer legacy)
  noGoalScorer: {
    en: "No goal scorer",
    fr: "Pas de buteur",
    es: "Sin goleador",
    ar: "لا يوجد هداف",
    jp: "得点者なし"
  },
  unknownPlayer: {
    en: "Unknown player",
    fr: "Joueur inconnu",
    es: "Jugador desconocido",
    ar: "لاعب غير معروف",
    jp: "不明なプレイヤー"
  },
  wrongPrediction: {
    en: "Wrong prediction",
    fr: "Mauvaise prédiction",
    es: "Predicción incorrecta",
    ar: "تنبؤ خاطئ",
    jp: "間違った予想"
  },
  exactScorePrediction: {
    en: "You predicted the exact score",
    fr: "Vous avez prédit le score exact",
    es: "Predijiste el marcador exacto",
    ar: "لقد توقعت النتيجة الصحيحة",
    jp: "正確なスコアを予想しました"
  },
  resultPrediction: {
    en: "You predicted the result (win, loss, draw)",
    fr: "Vous avez prédit le résultat (victoire, défaite, nul)",
    es: "Predijiste el resultado (victoria, derrota, empate)",
    ar: "لقد توقعت النتيجة (فوز، خسارة، تعادل)",
    jp: "結果を予想しました（勝ち、負け、引き分け）"
  },

  // Player info modal (cycling legacy)
  stage: {
    en: "Stage",
    fr: "Étape",
    es: "Etapa",
    ar: "مرحلة",
    jp: "ステージ"
  },
  position: {
    en: "Position",
    fr: "Position",
    es: "Posición",
    ar: "المركز",
    jp: "順位"
  },
  points: {
    en: "Points",
    fr: "Points",
    es: "Puntos",
    ar: "النقاط",
    jp: "ポイント"
  },

  // How to Play page translations
  howToPlayTitle: {
    en: "HOW TO PLAY",
    fr: "COMMENT JOUER",
    es: "CÓMO JUGAR",
    ar: "كيفية اللعب",
    jp: "遊び方"
  },
  gameRulesTitle: {
    en: "Game Rules",
    fr: "Règles du jeu",
    es: "Reglas del juego",
    ar: "قواعد اللعبة",
    jp: "ゲームルール"
  },

  // Game Rules - Main heading
  rulesMainHeading: {
    en: "Ring Magazine Fantasy Pick'em - Game Rules (Gameplay-Only)",
    fr: "Ring Magazine Fantasy Pick'em - Règles du jeu (Gameplay uniquement)",
    es: "Ring Magazine Fantasy Pick'em - Reglas del juego (Solo jugabilidad)",
    ar: "دوري الملاكمة الخيالي لمجلة Ring - قواعد اللعبة (اللعب فقط)",
    jp: "Ring Magazine Fantasy Pick'em - ゲームルール（ゲームプレイのみ）"
  },

  // Game Rules - Section 1: Overview
  rulesOverviewTitle: {
    en: "1) Overview",
    fr: "1) Aperçu",
    es: "1) Resumen",
    ar: "1) نظرة عامة",
    jp: "1) 概要"
  },
  rulesOverviewPara1: {
    en: "Ring Magazine Fantasy Pick'em (\"Fantasy\") is a free-to-play pick'em game. You earn points by making picks on Ring-curated bouts during a defined competition window. Your points contribute to the applicable leaderboards for Weekly (where offered), Quarterly, and Annual competitions.",
    fr: "Ring Magazine Fantasy Pick'em (\"Fantasy\") est un jeu de pronostics gratuit. Vous gagnez des points en faisant des choix sur des combats sélectionnés par Ring pendant une fenêtre de compétition définie. Vos points contribuent aux classements applicables pour les compétitions hebdomadaires (lorsqu'elles sont proposées), trimestrielles et annuelles.",
    es: "Ring Magazine Fantasy Pick'em (\"Fantasy\") es un juego gratuito de predicciones. Ganas puntos haciendo selecciones en combates curados por Ring durante una ventana de competición definida. Tus puntos contribuyen a las clasificaciones aplicables para competiciones semanales (donde se ofrecen), trimestrales y anuales.",
    ar: "دوري الملاكمة الخيالي لمجلة رينغ (\"Fantasy\") هو لعبة اختيارات مجانية. تكسب نقاطًا من خلال إجراء اختيارات على النزالات التي يختارها Ring خلال فترة منافسة محددة. تساهم نقاطك في لوحات الصدارة المعمول بها للمسابقات الأسبوعية (حيثما كانت متاحة) والفصلية والسنوية.",
    jp: "Ring Magazine Fantasy Pick'em（「Fantasy」）は無料で遊べるピックエムゲームです。定められた競技期間中にRingが厳選した試合で予想を行い、ポイントを獲得します。あなたのポイントは、週間（提供されている場合）、四半期、年間の各リーダーボードに反映されます。"
  },
  rulesOverviewPara2: {
    en: "These Game Rules explain how Fantasy works in gameplay terms, including competition windows, picks, scoring, Champion Pick, chips, leaderboards, and tie-breakers. Where these Game Rules require an operational decision (for example, bout inclusion, lock timing, or scoring edge cases), Ring's in-product presentation and determinations apply.",
    fr: "Ces règles du jeu expliquent le fonctionnement de Fantasy en termes de gameplay, y compris les fenêtres de compétition, les choix, le système de points, le Champion Pick, les jetons, les classements et les départages. Lorsque ces règles du jeu nécessitent une décision opérationnelle (par exemple, l'inclusion d'un combat, le moment de verrouillage ou les cas limites de notation), la présentation et les déterminations de Ring dans le produit s'appliquent.",
    es: "Estas reglas del juego explican cómo funciona Fantasy en términos de jugabilidad, incluyendo ventanas de competición, selecciones, puntuación, Champion Pick, fichas, clasificaciones y desempates. Cuando estas reglas del juego requieran una decisión operativa (por ejemplo, inclusión de combates, tiempo de bloqueo o casos límite de puntuación), se aplicará la presentación y determinaciones de Ring en el producto.",
    ar: "توضح قواعد اللعبة هذه كيفية عمل Fantasy من حيث اللعب، بما في ذلك فترات المنافسة والاختيارات والتسجيل واختيار البطل والرقائق ولوحات الصدارة وقواعد الفصل بين المتعادلين. عندما تتطلب قواعد اللعبة هذه قرارًا تشغيليًا (على سبيل المثال، إدراج النزال أو توقيت القفل أو حالات التسجيل الحدية)، تُطبق عروض وقرارات Ring داخل المنتج.",
    jp: "このゲームルールでは、競技期間、予想、スコアリング、チャンピオンピック、チップ、リーダーボード、タイブレーカーなど、ゲームプレイの観点からFantasyの仕組みを説明します。これらのゲームルールが運用上の決定（例えば、試合の採用、ロックのタイミング、スコアリングのエッジケース）を必要とする場合、Ringの製品内の表示と決定が適用されます。"
  },
  rulesOverviewPara3: {
    en: "These Game Rules should be read together with the Ring Magazine Fantasy Pick'em Terms & Conditions, which govern your participation in Fantasy and prevail in the event of any inconsistency.",
    fr: "Ces règles du jeu doivent être lues conjointement avec les conditions générales de Ring Magazine Fantasy Pick'em, qui régissent votre participation à Fantasy et prévalent en cas d'incohérence.",
    es: "Estas reglas del juego deben leerse junto con los Términos y Condiciones de Ring Magazine Fantasy Pick'em, que rigen tu participación en Fantasy y prevalecen en caso de cualquier inconsistencia.",
    ar: "يجب قراءة قواعد اللعبة هذه مع شروط وأحكام دوري الملاكمة الخيالي لمجلة Ring، التي تحكم مشاركتك في Fantasy وتسود في حالة وجود أي تناقض.",
    jp: "このゲームルールは、Fantasyへの参加を規定するRing Magazine Fantasy Pick'emの利用規約と併せてお読みください。矛盾がある場合は利用規約が優先されます。"
  },
  rulesOverviewPara3Before: {
    en: "These Game Rules should be read together with the ",
    fr: "Ces règles du jeu doivent être lues conjointement avec les ",
    es: "Estas reglas del juego deben leerse junto con los ",
    ar: "يجب قراءة قواعد اللعبة هذه مع ",
    jp: "このゲームルールは、Fantasyへの参加を規定する"
  },
  rulesOverviewPara3LinkText: {
    en: "Ring Magazine Fantasy Pick'em Terms & Conditions",
    fr: "conditions générales de Ring Magazine Fantasy Pick'em",
    es: "Términos y Condiciones de Ring Magazine Fantasy Pick'em",
    ar: "شروط وأحكام دوري الملاكمة الخيالي لمجلة Ring",
    jp: "Ring Magazine Fantasy Pick'emの利用規約"
  },
  rulesOverviewPara3After: {
    en: ", which govern your participation in Fantasy and prevail in the event of any inconsistency.",
    fr: ", qui régissent votre participation à Fantasy et prévalent en cas d'incohérence.",
    es: ", que rigen tu participación en Fantasy y prevalecen en caso de cualquier inconsistencia.",
    ar: "، التي تحكم مشاركتك في Fantasy وتسود في حالة وجود أي تناقض.",
    jp: "と併せてお読みください。矛盾がある場合は利用規約が優先されます。"
  },

  // Game Rules - Section 2: Competition periods
  rulesCompetitionTitle: {
    en: "2) Competition periods and minimum fights",
    fr: "2) Périodes de compétition et nombre minimum de combats",
    es: "2) Períodos de competición y peleas mínimas",
    ar: "2) فترات المنافسة والحد الأدنى من النزالات",
    jp: "2) 競技期間と最低試合数"
  },
  rulesCompetitionIntro: {
    en: "Fantasy may operate the following competition periods:",
    fr: "Fantasy peut fonctionner selon les périodes de compétition suivantes :",
    es: "Fantasy puede operar los siguientes períodos de competición:",
    ar: "قد تعمل Fantasy وفقًا لفترات المنافسة التالية:",
    jp: "Fantasyでは以下の競技期間が設定される場合があります："
  },
  rulesWeeklyTitle: {
    en: "2.1 Weekly competition windows (minimum bout requirement)",
    fr: "2.1 Fenêtres de compétition hebdomadaires (exigence minimale de combats)",
    es: "2.1 Ventanas de competición semanal (requisito mínimo de combates)",
    ar: "2.1 فترات المنافسة الأسبوعية (الحد الأدنى من النزالات المطلوبة)",
    jp: "2.1 週間競技期間（最低試合要件）"
  },
  rulesWeeklyBullet1: {
    en: "A weekly competition window will run only when there are at least four (4) eligible bouts in that window.",
    fr: "Une fenêtre de compétition hebdomadaire ne sera ouverte que lorsqu'il y aura au moins quatre (4) combats éligibles dans cette fenêtre.",
    es: "Una ventana de competición semanal solo se ejecutará cuando haya al menos cuatro (4) combates elegibles en esa ventana.",
    ar: "ستعمل فترة المنافسة الأسبوعية فقط عندما يكون هناك أربع (4) نزالات مؤهلة على الأقل في تلك الفترة.",
    jp: "週間競技期間は、その期間内に少なくとも4つの対象試合がある場合にのみ実施されます。"
  },
  rulesWeeklyBullet2: {
    en: "If fewer than four (4) eligible bouts are available in a calendar week, those bouts will be combined with one or more subsequent weeks to form a single competition window once the minimum number of eligible bouts (four (4) or more) is reached. The combined competition window will be clearly shown in the Platform.",
    fr: "Si moins de quatre (4) combats éligibles sont disponibles dans une semaine civile, ces combats seront combinés avec une ou plusieurs semaines suivantes pour former une seule fenêtre de compétition une fois que le nombre minimum de combats éligibles (quatre (4) ou plus) sera atteint. La fenêtre de compétition combinée sera clairement indiquée dans la Plateforme.",
    es: "Si hay menos de cuatro (4) combates elegibles disponibles en una semana calendario, esos combates se combinarán con una o más semanas posteriores para formar una única ventana de competición una vez que se alcance el número mínimo de combates elegibles (cuatro (4) o más). La ventana de competición combinada se mostrará claramente en la Plataforma.",
    ar: "إذا كان هناك أقل من أربع (4) نزالات مؤهلة متاحة في أسبوع تقويمي، فسيتم دمج تلك النزالات مع أسبوع أو أكثر من الأسابيع اللاحقة لتشكيل فترة منافسة واحدة بمجرد الوصول إلى الحد الأدنى من النزالات المؤهلة (أربعة (4) أو أكثر). سيتم عرض فترة المنافسة المدمجة بوضوح في المنصة.",
    jp: "暦週内で4つ未満の対象試合しかない場合、最低試合数（4試合以上）に達するまで、それらの試合は1つ以上の後続の週と統合されて単一の競技期間となります。統合された競技期間はプラットフォーム上で明確に表示されます。"
  },
  rulesQuarterlyTitle: {
    en: "2.2 Quarterly competitions",
    fr: "2.2 Compétitions trimestrielles",
    es: "2.2 Competiciones trimestrales",
    ar: "2.2 المسابقات الفصلية",
    jp: "2.2 四半期競技"
  },
  rulesQuarterlyIntro: {
    en: "Quarterly competitions follow standard calendar quarters, except in the first quarter:",
    fr: "Les compétitions trimestrielles suivent les trimestres civils standard, sauf pour le premier trimestre :",
    es: "Las competiciones trimestrales siguen los trimestres calendario estándar, excepto en el primer trimestre:",
    ar: "تتبع المسابقات الفصلية الأرباع التقويمية القياسية، باستثناء الربع الأول:",
    jp: "四半期競技は標準的な暦四半期に従いますが、第1四半期は除きます："
  },
  rulesQ1: {
    en: "Q1: Jan 30-Mar 31",
    fr: "T1 : 30 jan-31 mar",
    es: "T1: 30 ene-31 mar",
    ar: "الربع الأول: 30 يناير - 31 مارس",
    jp: "第1四半期：1月30日〜3月31日"
  },
  rulesQ2: {
    en: "Q2: Apr 1-Jun 30",
    fr: "T2 : 1 avr-30 jui",
    es: "T2: 1 abr-30 jun",
    ar: "الربع الثاني: 1 أبريل - 30 يونيو",
    jp: "第2四半期：4月1日〜6月30日"
  },
  rulesQ3: {
    en: "Q3: Jul 1-Sep 30",
    fr: "T3 : 1 jui-30 sep",
    es: "T3: 1 jul-30 sep",
    ar: "الربع الثالث: 1 يوليو - 30 سبتمبر",
    jp: "第3四半期：7月1日〜9月30日"
  },
  rulesQ4: {
    en: "Q4: Oct 1-Dec 31",
    fr: "T4 : 1 oct-31 déc",
    es: "T4: 1 oct-31 dic",
    ar: "الربع الرابع: 1 أكتوبر - 31 ديسمبر",
    jp: "第4四半期：10月1日〜12月31日"
  },
  rulesQuarterlyPoints: {
    en: "Quarterly points are the total points you earn from all settled competition windows that fall within that quarter.",
    fr: "Les points trimestriels sont le total des points que vous gagnez dans toutes les fenêtres de compétition réglées qui tombent dans ce trimestre.",
    es: "Los puntos trimestrales son el total de puntos que ganas en todas las ventanas de competición resueltas que caen dentro de ese trimestre.",
    ar: "النقاط الفصلية هي إجمالي النقاط التي تكسبها من جميع فترات المنافسة المحسومة التي تقع ضمن ذلك الربع.",
    jp: "四半期ポイントは、その四半期内で終了したすべての競技期間から獲得したポイントの合計です。"
  },
  rulesAnnualTitle: {
    en: "2.3 Annual competition",
    fr: "2.3 Compétition annuelle",
    es: "2.3 Competición anual",
    ar: "2.3 المسابقة السنوية",
    jp: "2.3 年間競技"
  },
  rulesAnnualPeriod: {
    en: "The annual competition runs January 30, 2026 - December 31, 2026.",
    fr: "La compétition annuelle se déroule du 30 janvier 2026 au 31 décembre 2026.",
    es: "La competición anual se desarrolla del 30 de enero de 2026 al 31 de diciembre de 2026.",
    ar: "تستمر المسابقة السنوية من 30 يناير 2026 إلى 31 ديسمبر 2026.",
    jp: "年間競技は2026年1月30日から2026年12月31日まで開催されます。"
  },
  rulesAnnualPoints: {
    en: "Annual points are the total points you earn from all settled competition windows during the annual period.",
    fr: "Les points annuels sont le total des points que vous gagnez dans toutes les fenêtres de compétition réglées pendant la période annuelle.",
    es: "Los puntos anuales son el total de puntos que ganas en todas las ventanas de competición resueltas durante el período anual.",
    ar: "النقاط السنوية هي إجمالي النقاط التي تكسبها من جميع فترات المنافسة المحسومة خلال الفترة السنوية.",
    jp: "年間ポイントは、年間期間中に終了したすべての競技期間から獲得したポイントの合計です。"
  },

  // Game Rules - Section 3: Eligible cards and bouts
  rulesEligibleTitle: {
    en: "3) Eligible cards and bouts",
    fr: "3) Cartes et combats éligibles",
    es: "3) Cartas y combates elegibles",
    ar: "3) البطاقات والنزالات المؤهلة",
    jp: "3) 対象カードと試合"
  },
  rulesCurationTitle: {
    en: "3.1 Editorial curation",
    fr: "3.1 Curation éditoriale",
    es: "3.1 Curación editorial",
    ar: "3.1 الاختيار التحريري",
    jp: "3.1 編集による選定"
  },
  rulesCurationBullet1: {
    en: "Ring curates eligible cards and bouts for Fantasy.",
    fr: "Ring sélectionne les cartes et combats éligibles pour Fantasy.",
    es: "Ring cura las cartas y combates elegibles para Fantasy.",
    ar: "يختار Ring البطاقات والنزالات المؤهلة لـ Fantasy.",
    jp: "RingがFantasyの対象カードと試合を選定します。"
  },
  rulesCurationBullet2: {
    en: "Inclusion decisions are at Ring's sole discretion and may consider factors such as competitive significance, broadcast availability, and scheduling certainty.",
    fr: "Les décisions d'inclusion sont à la seule discrétion de Ring et peuvent prendre en compte des facteurs tels que l'importance compétitive, la disponibilité de diffusion et la certitude de programmation.",
    es: "Las decisiones de inclusión son a exclusiva discreción de Ring y pueden considerar factores como la importancia competitiva, la disponibilidad de transmisión y la certeza de programación.",
    ar: "قرارات الإدراج تقع على عاتق Ring وحدها وقد تأخذ في الاعتبار عوامل مثل الأهمية التنافسية وتوفر البث واليقين في الجدولة.",
    jp: "採用の決定はRingの独自の裁量に委ねられ、競技的重要性、放送の可否、スケジュールの確実性などの要因が考慮される場合があります。"
  },
  rulesCurationBullet3: {
    en: "Ring may add, remove, or reschedule bouts at any time before locks are applied.",
    fr: "Ring peut ajouter, supprimer ou reprogrammer des combats à tout moment avant l'application des verrouillages.",
    es: "Ring puede agregar, eliminar o reprogramar combates en cualquier momento antes de que se apliquen los bloqueos.",
    ar: "قد يضيف Ring أو يزيل أو يعيد جدولة النزالات في أي وقت قبل تطبيق القفل.",
    jp: "Ringはロックが適用される前であれば、いつでも試合を追加、削除、または再スケジュールすることができます。"
  },
  rulesCurationBullet2Alt: {
    en: "Ring typically curates 4-6 fight cards per week (where available), but may curate fewer or more depending on the schedule.",
    fr: "Ring sélectionne généralement 4 à 6 cartes de combat par semaine (lorsque disponible), mais peut en sélectionner moins ou plus selon le calendrier.",
    es: "Ring típicamente cura 4-6 carteleras de pelea por semana (cuando están disponibles), pero puede curar menos o más dependiendo del calendario.",
    ar: "يختار Ring عادةً من 4 إلى 6 بطاقات قتال أسبوعيًا (حيثما كان ذلك متاحًا)، ولكن قد يختار أقل أو أكثر حسب الجدول الزمني.",
    jp: "Ringは通常、週に4〜6枚のファイトカードを選定します（利用可能な場合）が、スケジュールによってはそれより少ないまたは多い場合があります。"
  },
  rulesCurationBullet3Alt: {
    en: "Not all fights on a card will be included. Ring may exclude prelims or non-feature bouts.",
    fr: "Tous les combats d'une carte ne seront pas inclus. Ring peut exclure les combats préliminaires ou les combats non vedettes.",
    es: "No se incluirán todas las peleas de una cartelera. Ring puede excluir peleas preliminares o combates que no sean estelares.",
    ar: "لن يتم تضمين جميع النزالات على البطاقة. قد يستبعد Ring النزالات الافتتاحية أو النزالات غير الرئيسية.",
    jp: "カード上のすべての試合が含まれるわけではありません。Ringは前座試合やメインでない試合を除外する場合があります。"
  },
  rulesInProductTitle: {
    en: "3.2 What you will see in-product",
    fr: "3.2 Ce que vous verrez dans le produit",
    es: "3.2 Lo que verás en el producto",
    ar: "3.2 ما ستراه في المنتج",
    jp: "3.2 製品内で表示される内容"
  },
  rulesInProductIntro: {
    en: "For each competition window, the Platform will show:",
    fr: "Pour chaque fenêtre de compétition, la Plateforme affichera :",
    es: "Para cada ventana de competición, la Plataforma mostrará:",
    ar: "لكل فترة منافسة، ستعرض المنصة:",
    jp: "各競技期間について、プラットフォームには以下が表示されます："
  },
  rulesInProductBullet1: {
    en: "the eligible bouts,",
    fr: "les combats éligibles,",
    es: "los combates elegibles,",
    ar: "النزالات المؤهلة،",
    jp: "対象試合、"
  },
  rulesInProductBullet2: {
    en: "what pick options are available (e.g., winner; method; round-specific KO/TKO where offered),",
    fr: "quelles options de choix sont disponibles (par exemple, vainqueur ; méthode ; KO/TKO spécifique au round lorsque proposé),",
    es: "qué opciones de selección están disponibles (por ejemplo, ganador; método; KO/TKO específico de round cuando se ofrezca),",
    ar: "خيارات الاختيار المتاحة (على سبيل المثال، الفائز؛ الطريقة؛ KO/TKO محدد بالجولة حيثما كان معروضًا)،",
    jp: "利用可能な予想オプション（例：勝者、方法、提供される場合はラウンド固有のKO/TKO）、"
  },
  rulesInProductBullet3: {
    en: "the lock time for the event and/or each bout,",
    fr: "l'heure de verrouillage pour l'événement et/ou chaque combat,",
    es: "el tiempo de bloqueo para el evento y/o cada combate,",
    ar: "وقت القفل للحدث و/أو كل نزال،",
    jp: "イベントおよび/または各試合のロック時間、"
  },
  rulesInProductBullet4: {
    en: "and the applicable leaderboard(s).",
    fr: "et le(s) classement(s) applicable(s).",
    es: "y la(s) clasificación(es) aplicable(s).",
    ar: "ولوحة (لوحات) الصدارة المعمول بها.",
    jp: "該当するリーダーボード。"
  },
  rulesInProductClosing: {
    en: "Ring may add, remove, or adjust eligible bouts before lock where needed for scheduling, integrity, or operational reasons, and will reflect the final eligible slate in-product.",
    fr: "Ring peut ajouter, supprimer ou ajuster les combats éligibles avant le verrouillage si nécessaire pour des raisons de programmation, d'intégrité ou opérationnelles, et reflétera la liste finale éligible dans le produit.",
    es: "Ring puede agregar, eliminar o ajustar combates elegibles antes del bloqueo cuando sea necesario por razones de programación, integridad u operativas, y reflejará la lista final elegible en el producto.",
    ar: "قد يضيف Ring أو يزيل أو يعدل النزالات المؤهلة قبل القفل حيثما كان ذلك ضروريًا لأسباب الجدولة أو النزاهة أو التشغيل، وسيعكس القائمة النهائية المؤهلة في المنتج.",
    jp: "Ringはスケジューリング、完全性、または運用上の理由から必要に応じて、ロック前に対象試合を追加、削除、または調整する場合があり、製品内で最終的な対象スレートを反映します。"
  },
  rulesBoutEligibilityTitle: {
    en: "3.2 Bout eligibility",
    fr: "3.2 Éligibilité des combats",
    es: "3.2 Elegibilidad de combates",
    ar: "3.2 أهلية النزال",
    jp: "3.2 試合の対象条件"
  },
  rulesBoutEligibility: {
    en: "A bout is eligible for Fantasy if it is selected by Ring's editorial team and appears in the Platform's competition window. Only bouts that are officially sanctioned and scheduled will be included.",
    fr: "Un combat est éligible pour Fantasy s'il est sélectionné par l'équipe éditoriale de Ring et apparaît dans la fenêtre de compétition de la Plateforme. Seuls les combats officiellement sanctionnés et programmés seront inclus.",
    es: "Un combate es elegible para Fantasy si es seleccionado por el equipo editorial de Ring y aparece en la ventana de competición de la Plataforma. Solo se incluirán combates oficialmente sancionados y programados.",
    ar: "يكون النزال مؤهلاً لـ Fantasy إذا تم اختياره من قبل فريق التحرير في Ring ويظهر في فترة منافسة المنصة. سيتم تضمين النزالات المعتمدة والمجدولة رسميًا فقط.",
    jp: "試合がFantasyの対象となるのは、Ringの編集チームによって選定され、プラットフォームの競技期間に表示される場合です。公式に認可され、スケジュールされた試合のみが含まれます。"
  },

  // Game Rules - Section 4: Picks and lock times
  rulesPicksLockTimesTitle: {
    en: "4) Picks and lock times",
    fr: "4) Choix et temps de verrouillage",
    es: "4) Selecciones y tiempos de bloqueo",
    ar: "4) الاختيارات وأوقات القفل",
    jp: "4) 予想とロック時間"
  },
  rulesLockingDeadlinesTitle: {
    en: "4.1 Locking / Deadlines",
    fr: "4.1 Verrouillage / Dates limites",
    es: "4.1 Bloqueo / Fechas límite",
    ar: "4.1 القفل / المواعيد النهائية",
    jp: "4.1 ロック / 締切"
  },
  rulesLockingBullet1: {
    en: "Picks lock at the fight/event start time shown in the Platform deadline.",
    fr: "Les choix sont verrouillés à l'heure de début du combat/événement indiquée dans la date limite de la Plateforme.",
    es: "Las selecciones se bloquean en la hora de inicio de la pelea/evento que se muestra en la fecha límite de la Plataforma.",
    ar: "يتم قفل الاختيارات في وقت بدء القتال/الحدث المعروض في الموعد النهائي للمنصة.",
    jp: "予想はプラットフォームの締切に表示されている試合/イベントの開始時刻にロックされます。"
  },
  rulesLockingBullet2: {
    en: "If individual bout start times are shown, picks lock per bout (later bouts may remain pickable until they start).",
    fr: "Si les heures de début individuelles des combats sont indiquées, les choix sont verrouillés par combat (les combats ultérieurs peuvent rester sélectionnables jusqu'à leur début).",
    es: "Si se muestran los horarios de inicio individuales de los combates, las selecciones se bloquean por combate (los combates posteriores pueden seguir siendo seleccionables hasta que comiencen).",
    ar: "إذا تم عرض أوقات بدء النزالات الفردية، يتم قفل الاختيارات لكل نزال (قد تظل النزالات اللاحقة قابلة للاختيار حتى تبدأ).",
    jp: "個別の試合開始時刻が表示されている場合、予想は試合ごとにロックされます（後の試合は開始まで予想可能な状態が続く場合があります）。"
  },
  rulesLockingBullet3: {
    en: "Picks cannot be changed after lock.",
    fr: "Les choix ne peuvent pas être modifiés après le verrouillage.",
    es: "Las selecciones no se pueden cambiar después del bloqueo.",
    ar: "لا يمكن تغيير الاختيارات بعد القفل.",
    jp: "ロック後は予想を変更できません。"
  },
  rulesPartialParticipationTitle: {
    en: "4.2 Partial participation",
    fr: "4.2 Participation partielle",
    es: "4.2 Participación parcial",
    ar: "4.2 المشاركة الجزئية",
    jp: "4.2 部分参加"
  },
  rulesPartialBullet1: {
    en: "You may pick some bouts and skip others.",
    fr: "Vous pouvez choisir certains combats et en ignorer d'autres.",
    es: "Puedes seleccionar algunos combates y omitir otros.",
    ar: "يمكنك اختيار بعض النزالات وتخطي البعض الآخر.",
    jp: "一部の試合を予想し、他の試合をスキップすることができます。"
  },
  rulesPartialBullet2: {
    en: "Any unpicked bout scores 0 points for that user.",
    fr: "Tout combat non choisi rapporte 0 point pour cet utilisateur.",
    es: "Cualquier combate no seleccionado otorga 0 puntos para ese usuario.",
    ar: "أي نزال لم يتم اختياره يحصل على 0 نقطة لذلك المستخدم.",
    jp: "予想していない試合は、そのユーザーに対して0ポイントになります。"
  },

  // Game Rules - Section 4: Making picks (alternate version)
  rulesMakingPicksTitle: {
    en: "4) Making picks",
    fr: "4) Faire des choix",
    es: "4) Hacer selecciones",
    ar: "4) إجراء الاختيارات",
    jp: "4) 予想を行う"
  },
  rulesPickTypesTitle: {
    en: "4.1 Pick types",
    fr: "4.1 Types de choix",
    es: "4.1 Tipos de selección",
    ar: "4.1 أنواع الاختيارات",
    jp: "4.1 予想の種類"
  },
  rulesPickTypesIntro: {
    en: "For each eligible bout, you may make the following picks:",
    fr: "Pour chaque combat éligible, vous pouvez faire les choix suivants :",
    es: "Para cada combate elegible, puedes hacer las siguientes selecciones:",
    ar: "لكل نزال مؤهل، يمكنك إجراء الاختيارات التالية:",
    jp: "対象となる各試合について、以下の予想を行うことができます："
  },
  rulesWinnerPick: {
    en: "Winner Pick: Select which fighter will win the bout.",
    fr: "Choix du vainqueur : Sélectionnez quel combattant gagnera le combat.",
    es: "Selección del ganador: Selecciona qué luchador ganará el combate.",
    ar: "اختيار الفائز: اختر المقاتل الذي سيفوز بالنزال.",
    jp: "勝者予想：どのファイターが試合に勝つかを選択します。"
  },
  rulesMethodVictory: {
    en: "Method of Victory: Predict how the bout will end (KO/TKO, Decision, etc.).",
    fr: "Méthode de victoire : Prédisez comment le combat se terminera (KO/TKO, Décision, etc.).",
    es: "Método de victoria: Predice cómo terminará el combate (KO/TKO, Decisión, etc.).",
    ar: "طريقة الفوز: توقع كيف سينتهي النزال (KO/TKO، قرار، إلخ).",
    jp: "勝利方法：試合がどのように終わるか予想します（KO/TKO、判定など）。"
  },
  rulesRoundPick: {
    en: "Round Pick: Predict in which round the bout will end (if applicable).",
    fr: "Choix du round : Prédisez dans quel round le combat se terminera (le cas échéant).",
    es: "Selección de round: Predice en qué round terminará el combate (si aplica).",
    ar: "اختيار الجولة: توقع في أي جولة سينتهي النزال (إن أمكن).",
    jp: "ラウンド予想：試合が何ラウンドで終わるか予想します（該当する場合）。"
  },
  rulesLockTimingTitle: {
    en: "4.2 Lock timing",
    fr: "4.2 Moment de verrouillage",
    es: "4.2 Tiempo de bloqueo",
    ar: "4.2 توقيت القفل",
    jp: "4.2 ロックのタイミング"
  },
  rulesLockTiming: {
    en: "Picks lock at the scheduled start time of each bout. Once a bout is locked, you cannot change your picks for that bout. The Platform will clearly display lock times for all bouts.",
    fr: "Les choix sont verrouillés à l'heure de début prévue de chaque combat. Une fois qu'un combat est verrouillé, vous ne pouvez plus modifier vos choix pour ce combat. La Plateforme affichera clairement les heures de verrouillage pour tous les combats.",
    es: "Las selecciones se bloquean a la hora de inicio programada de cada combate. Una vez que un combate está bloqueado, no puedes cambiar tus selecciones para ese combate. La Plataforma mostrará claramente los tiempos de bloqueo para todos los combates.",
    ar: "يتم قفل الاختيارات في وقت البدء المجدول لكل نزال. بمجرد قفل النزال، لا يمكنك تغيير اختياراتك لذلك النزال. ستعرض المنصة بوضوح أوقات القفل لجميع النزالات.",
    jp: "予想は各試合の予定開始時刻にロックされます。試合がロックされると、その試合の予想を変更することはできません。プラットフォームにはすべての試合のロック時間が明確に表示されます。"
  },

  // Game Rules - Section 5: Disruptions, bout status, and void bouts
  rulesDisruptionsTitle: {
    en: "5) Disruptions, bout status, and void bouts",
    fr: "5) Perturbations, statut des combats et combats annulés",
    es: "5) Interrupciones, estado de combates y combates anulados",
    ar: "5) الاضطرابات وحالة النزال والنزالات الملغاة",
    jp: "5) 中断、試合状況、および無効試合"
  },
  rulesDisruptionsIntro: {
    en: "Fantasy must handle real-world disruptions (cancellations, postponements, commission rulings) consistently and fairly.",
    fr: "Fantasy doit gérer les perturbations du monde réel (annulations, reports, décisions des commissions) de manière cohérente et équitable.",
    es: "Fantasy debe manejar las interrupciones del mundo real (cancelaciones, aplazamientos, decisiones de comisiones) de manera consistente y justa.",
    ar: "يجب على Fantasy التعامل مع الاضطرابات في العالم الحقيقي (الإلغاءات والتأجيلات وقرارات اللجان) بشكل متسق وعادل.",
    jp: "Fantasyは、現実世界の中断（キャンセル、延期、コミッションの裁定）を一貫して公平に処理する必要があります。"
  },
  rulesCancelledPostponedTitle: {
    en: "5.1 Cancelled or postponed bouts",
    fr: "5.1 Combats annulés ou reportés",
    es: "5.1 Combates cancelados o pospuestos",
    ar: "5.1 النزالات الملغاة أو المؤجلة",
    jp: "5.1 キャンセルまたは延期された試合"
  },
  rulesCancelledPostponedIntro: {
    en: "If a bout is cancelled or postponed:",
    fr: "Si un combat est annulé ou reporté :",
    es: "Si un combate es cancelado o pospuesto:",
    ar: "إذا تم إلغاء نزال أو تأجيله:",
    jp: "試合がキャンセルまたは延期された場合："
  },
  rulesCancelledBullet1: {
    en: "the bout is treated as void for Fantasy scoring, and all users score 0 points for that bout; and",
    fr: "le combat est traité comme annulé pour le score Fantasy, et tous les utilisateurs marquent 0 point pour ce combat ; et",
    es: "el combate se trata como anulado para la puntuación de Fantasy, y todos los usuarios obtienen 0 puntos por ese combate; y",
    ar: "يُعامل النزال على أنه ملغى لتسجيل Fantasy، ويحصل جميع المستخدمين على 0 نقطة لذلك النزال؛ و",
    jp: "その試合はFantasyスコアリングにおいて無効として扱われ、すべてのユーザーはその試合で0ポイントになります。そして"
  },
  rulesCancelledBullet2: {
    en: "any chip that was activated for the relevant competition window is not refunded, reset, or replaced as a result of the bout being void, and has no effect in relation to that bout",
    fr: "tout jeton activé pour la fenêtre de compétition concernée n'est pas remboursé, réinitialisé ou remplacé suite à l'annulation du combat, et n'a aucun effet concernant ce combat",
    es: "cualquier ficha que se haya activado para la ventana de competición relevante no se reembolsa, restablece o reemplaza como resultado de la anulación del combate, y no tiene efecto en relación con ese combate",
    ar: "أي رقاقة تم تفعيلها لفترة المنافسة ذات الصلة لا يتم استردادها أو إعادة ضبطها أو استبدالها نتيجة لإلغاء النزال، وليس لها أي تأثير فيما يتعلق بذلك النزال",
    jp: "該当する競技期間で有効化されたチップは、試合が無効になった結果として返金、リセット、または交換されず、その試合に関して効果がありません"
  },
  rulesOpponentReplacementsTitle: {
    en: "5.2 Opponent replacements",
    fr: "5.2 Remplacements d'adversaires",
    es: "5.2 Reemplazos de oponentes",
    ar: "5.2 استبدال الخصوم",
    jp: "5.2 対戦相手の変更"
  },
  rulesOpponentBullet1: {
    en: "If an opponent is replaced five (5) or more days before the scheduled bout start time, and subject to Ring having sufficient time to update the Platform and allow users a reasonable opportunity to re-pick, Ring may list the replacement bout and permit picks.",
    fr: "Si un adversaire est remplacé cinq (5) jours ou plus avant l'heure de début prévue du combat, et sous réserve que Ring dispose de suffisamment de temps pour mettre à jour la Plateforme et permettre aux utilisateurs une opportunité raisonnable de refaire leurs choix, Ring peut lister le combat de remplacement et autoriser les choix.",
    es: "Si un oponente es reemplazado cinco (5) o más días antes de la hora de inicio programada del combate, y sujeto a que Ring tenga tiempo suficiente para actualizar la Plataforma y permitir a los usuarios una oportunidad razonable para volver a elegir, Ring puede listar el combate de reemplazo y permitir selecciones.",
    ar: "إذا تم استبدال خصم قبل خمسة (5) أيام أو أكثر من وقت بدء النزال المجدول، ورهناً بأن يكون لدى Ring وقت كافٍ لتحديث المنصة والسماح للمستخدمين بفرصة معقولة لإعادة الاختيار، قد تدرج Ring نزال الاستبدال وتسمح بالاختيارات.",
    jp: "予定試合開始時刻の5日以上前に対戦相手が交代し、Ringがプラットフォームを更新してユーザーに合理的な再予想の機会を提供するのに十分な時間がある場合、Ringは代替試合をリストアップして予想を許可する場合があります。"
  },
  rulesOpponentBullet2: {
    en: "If an opponent replacement occurs less than five (5) days before the scheduled bout start time, the original bout will be treated as void for Fantasy scoring (0 points for all users), unless Ring clearly states an alternative handling for that specific bout in the Platform.",
    fr: "Si un remplacement d'adversaire survient moins de cinq (5) jours avant l'heure de début prévue du combat, le combat original sera traité comme annulé pour le score Fantasy (0 point pour tous les utilisateurs), sauf si Ring indique clairement une gestion alternative pour ce combat spécifique dans la Plateforme.",
    es: "Si un reemplazo de oponente ocurre menos de cinco (5) días antes de la hora de inicio programada del combate, el combate original se tratará como anulado para la puntuación de Fantasy (0 puntos para todos los usuarios), a menos que Ring indique claramente un manejo alternativo para ese combate específico en la Plataforma.",
    ar: "إذا حدث استبدال خصم قبل أقل من خمسة (5) أيام من وقت بدء النزال المجدول، فسيتم التعامل مع النزال الأصلي على أنه ملغى لتسجيل Fantasy (0 نقطة لجميع المستخدمين)، ما لم تحدد Ring بوضوح معالجة بديلة لذلك النزال المحدد في المنصة.",
    jp: "予定試合開始時刻の5日未満前に対戦相手の交代が発生した場合、Ringがプラットフォーム上でその特定の試合について代替の取り扱いを明確に述べない限り、元の試合はFantasyスコアリングにおいて無効として扱われます（すべてのユーザーに0ポイント）。"
  },
  rulesNoContestDrawsTitle: {
    en: "5.3 No Contest and Draws",
    fr: "5.3 No Contest et matchs nuls",
    es: "5.3 Sin resultado y empates",
    ar: "5.3 بدون نتيجة والتعادلات",
    jp: "5.3 ノーコンテストと引き分け"
  },
  rulesNoContestBullet: {
    en: "<strong>No Contest:</strong> treated as void for Fantasy scoring, 0 points for all users.",
    fr: "<strong>No Contest :</strong> traité comme annulé pour le score Fantasy, 0 point pour tous les utilisateurs.",
    es: "<strong>Sin resultado:</strong> tratado como anulado para la puntuación de Fantasy, 0 puntos para todos los usuarios.",
    ar: "<strong>بدون نتيجة:</strong> يُعامل على أنه ملغى لتسجيل Fantasy، 0 نقطة لجميع المستخدمين.",
    jp: "<strong>ノーコンテスト:</strong> Fantasyスコアリングにおいて無効として扱われ、すべてのユーザーに0ポイント。"
  },
  rulesDrawBullet: {
    en: "<strong>Draw</strong> (including split draw, majority draw, unanimous draw): treated as void for Fantasy scoring, 0 points for all users.",
    fr: "<strong>Match nul</strong> (y compris nul partagé, nul majoritaire, nul unanime) : traité comme annulé pour le score Fantasy, 0 point pour tous les utilisateurs.",
    es: "<strong>Empate</strong> (incluyendo empate dividido, empate mayoritario, empate unánime): tratado como anulado para la puntuación de Fantasy, 0 puntos para todos los usuarios.",
    ar: "<strong>التعادل</strong> (بما في ذلك التعادل المنقسم، والتعادل بالأغلبية، والتعادل بالإجماع): يُعامل على أنه ملغى لتسجيل Fantasy، 0 نقطة لجميع المستخدمين.",
    jp: "<strong>引き分け</strong>（スプリットドロー、マジョリティドロー、全員一致の引き分けを含む）：Fantasyスコアリングにおいて無効として扱われ、すべてのユーザーに0ポイント。"
  },

  // Game Rules - Section 6: Scoring and official results
  rulesScoringOfficialResultsTitle: {
    en: "6) Scoring and official results",
    fr: "6) Notation et résultats officiels",
    es: "6) Puntuación y resultados oficiales",
    ar: "6) التسجيل والنتائج الرسمية",
    jp: "6) スコアリングと公式結果"
  },
  rulesOfficialResultsSourcesTitle: {
    en: "6.1 Official results sources",
    fr: "6.1 Sources de résultats officiels",
    es: "6.1 Fuentes de resultados oficiales",
    ar: "6.1 مصادر النتائج الرسمية",
    jp: "6.1 公式結果のソース"
  },
  rulesOfficialBullet1: {
    en: "<strong>Primary source:</strong> the official in-venue/commission-announced result (as announced by the ring announcer or relevant governing body).",
    fr: "<strong>Source principale :</strong> le résultat officiel annoncé sur place/par la commission (tel qu'annoncé par l'annonceur du ring ou l'organisme directeur concerné).",
    es: "<strong>Fuente principal:</strong> el resultado oficial anunciado en el lugar/por la comisión (según lo anunciado por el presentador del ring o el órgano rector relevante).",
    ar: "<strong>المصدر الأساسي:</strong> النتيجة الرسمية المعلنة في المكان/من قبل اللجنة (كما أعلنها مذيع الحلبة أو الهيئة الحاكمة ذات الصلة).",
    jp: "<strong>主要ソース:</strong> 会場/コミッション発表の公式結果（リングアナウンサーまたは関連統括団体によって発表されたもの）。"
  },
  rulesOfficialBullet2: {
    en: "<strong>Secondary reference:</strong> BoxRec; www.boxrec.com.",
    fr: "<strong>Référence secondaire :</strong> BoxRec ; www.boxrec.com.",
    es: "<strong>Referencia secundaria:</strong> BoxRec; www.boxrec.com.",
    ar: "<strong>المرجع الثانوي:</strong> BoxRec؛ www.boxrec.com.",
    jp: "<strong>セカンダリリファレンス:</strong> BoxRec; www.boxrec.com。"
  },
  rulesOfficialBullet3: {
    en: "If there is a discrepancy, Ring in its sole discretion determines the scoring outcome used for Fantasy.",
    fr: "En cas de divergence, Ring détermine à sa seule discrétion le résultat de score utilisé pour Fantasy.",
    es: "Si hay una discrepancia, Ring a su sola discreción determina el resultado de puntuación utilizado para Fantasy.",
    ar: "في حالة وجود تناقض، تحدد Ring وفقًا لتقديرها الخاص نتيجة التسجيل المستخدمة لـ Fantasy.",
    jp: "不一致がある場合、Ringが独自の裁量でFantasyに使用するスコアリング結果を決定します。"
  },
  rulesOfficialBullet4: {
    en: "These sources and determinations apply to all Fantasy outcomes, including scoring, bonuses, Champion Pick multipliers, chip effects, leaderboards, and tie-breakers.",
    fr: "Ces sources et déterminations s'appliquent à tous les résultats Fantasy, y compris les scores, les bonus, les multiplicateurs Champion Pick, les effets de jetons, les classements et les départages.",
    es: "Estas fuentes y determinaciones se aplican a todos los resultados de Fantasy, incluidas las puntuaciones, bonificaciones, multiplicadores de Champion Pick, efectos de fichas, clasificaciones y desempates.",
    ar: "تنطبق هذه المصادر والقرارات على جميع نتائج Fantasy، بما في ذلك التسجيل والمكافآت ومضاعفات اختيار البطل وتأثيرات الرقائق ولوحات الصدارة وقواعد الفصل.",
    jp: "これらのソースと決定は、スコアリング、ボーナス、チャンピオンピック倍率、チップ効果、リーダーボード、タイブレーカーを含むすべてのFantasy結果に適用されます。"
  },
  rulesScoringSettledTitle: {
    en: "6.2 Scoring is settled (frozen)",
    fr: "6.2 Le score est figé (gelé)",
    es: "6.2 La puntuación está liquidada (congelada)",
    ar: "6.2 التسجيل محسوم (مجمد)",
    jp: "6.2 スコアリングは確定（凍結）"
  },
  rulesScoringSettledPara1: {
    en: "Once a bout is settled for Fantasy scoring, points are frozen. For the purposes of Fantasy, a bout is generally considered settled within a reasonable period after the official result is announced and reflected in the Platform (typically within seventy-two (72) hours after the event concludes), unless Ring notifies users otherwise due to integrity checks, technical issues, or exceptional circumstances.",
    fr: "Une fois qu'un combat est réglé pour le score Fantasy, les points sont gelés. Aux fins de Fantasy, un combat est généralement considéré comme réglé dans un délai raisonnable après que le résultat officiel est annoncé et reflété dans la Plateforme (généralement dans les soixante-douze (72) heures après la conclusion de l'événement), sauf si Ring en informe autrement les utilisateurs en raison de vérifications d'intégrité, de problèmes techniques ou de circonstances exceptionnelles.",
    es: "Una vez que un combate está liquidado para la puntuación de Fantasy, los puntos se congelan. Para los fines de Fantasy, un combate se considera generalmente liquidado dentro de un período razonable después de que se anuncia el resultado oficial y se refleja en la Plataforma (típicamente dentro de las setenta y dos (72) horas después de que concluye el evento), a menos que Ring notifique a los usuarios de otra manera debido a verificaciones de integridad, problemas técnicos o circunstancias excepcionales.",
    ar: "بمجرد حسم نزال لتسجيل Fantasy، يتم تجميد النقاط. لأغراض Fantasy، يُعتبر النزال محسومًا بشكل عام خلال فترة معقولة بعد الإعلان عن النتيجة الرسمية وانعكاسها في المنصة (عادةً في غضون اثنتين وسبعين (72) ساعة بعد انتهاء الحدث)، ما لم يخطر Ring المستخدمين بخلاف ذلك بسبب فحوصات النزاهة أو المشكلات الفنية أو الظروف الاستثنائية.",
    jp: "Fantasyスコアリングのために試合が確定すると、ポイントは凍結されます。Fantasyの目的上、試合は一般的に、公式結果が発表されてプラットフォームに反映された後の合理的な期間内（通常、イベント終了後72時間以内）に確定したと見なされます。ただし、完全性チェック、技術的問題、または例外的な状況により、Ringがユーザーに別途通知した場合を除きます。"
  },
  rulesScoringSettledPara2: {
    en: "Later changes (including amended results, reclassifications, or commission revisions after the event) do not trigger re-scoring.",
    fr: "Les modifications ultérieures (y compris les résultats modifiés, les reclassifications ou les révisions de commission après l'événement) ne déclenchent pas de re-notation.",
    es: "Los cambios posteriores (incluyendo resultados modificados, reclasificaciones o revisiones de comisiones después del evento) no desencadenan una re-puntuación.",
    ar: "التغييرات اللاحقة (بما في ذلك النتائج المعدلة أو إعادة التصنيف أو مراجعات اللجنة بعد الحدث) لا تؤدي إلى إعادة التسجيل.",
    jp: "後の変更（イベント後の修正結果、再分類、またはコミッションの改訂を含む）は、再スコアリングをトリガーしません。"
  },

  // Game Rules - Section 5: Scoring (alternate - keeping for backward compatibility)
  rulesScoringTitle: {
    en: "5) Scoring",
    fr: "5) Notation",
    es: "5) Puntuación",
    ar: "5) التسجيل",
    jp: "5) スコアリング"
  },
  rulesScoringIntro: {
    en: "Points are awarded based on the accuracy of your picks. The scoring system rewards both correct predictions and the difficulty of those predictions.",
    fr: "Les points sont attribués en fonction de la précision de vos choix. Le système de notation récompense à la fois les prédictions correctes et la difficulté de ces prédictions.",
    es: "Los puntos se otorgan según la precisión de tus selecciones. El sistema de puntuación recompensa tanto las predicciones correctas como la dificultad de esas predicciones.",
    ar: "تُمنح النقاط بناءً على دقة اختياراتك. يكافئ نظام التسجيل التوقعات الصحيحة وصعوبة تلك التوقعات.",
    jp: "ポイントは予想の正確さに基づいて付与されます。スコアリングシステムは正確な予想と、その予想の難易度の両方を評価します。"
  },
  rulesScoringBullet1: {
    en: "Correct winner picks earn base points.",
    fr: "Les choix de vainqueur corrects rapportent des points de base.",
    es: "Las selecciones correctas de ganador otorgan puntos base.",
    ar: "تكسب اختيارات الفائز الصحيحة نقاطًا أساسية.",
    jp: "正確な勝者予想で基本ポイントを獲得します。"
  },
  rulesScoringBullet2: {
    en: "Correct method of victory picks earn bonus points.",
    fr: "Les choix de méthode de victoire corrects rapportent des points bonus.",
    es: "Las selecciones correctas del método de victoria otorgan puntos de bonificación.",
    ar: "تكسب اختيارات طريقة الفوز الصحيحة نقاطًا إضافية.",
    jp: "正確な勝利方法予想でボーナスポイントを獲得します。"
  },
  rulesScoringBullet3: {
    en: "Correct round picks earn additional bonus points.",
    fr: "Les choix de round corrects rapportent des points bonus supplémentaires.",
    es: "Las selecciones correctas de round otorgan puntos de bonificación adicionales.",
    ar: "تكسب اختيارات الجولة الصحيحة نقاطًا إضافية.",
    jp: "正確なラウンド予想で追加ボーナスポイントを獲得します。"
  },
  rulesScoringBullet4: {
    en: "Champion Pick selections may earn multiplied points.",
    fr: "Les sélections de Champion Pick peuvent rapporter des points multipliés.",
    es: "Las selecciones de Champion Pick pueden ganar puntos multiplicados.",
    ar: "قد تكسب اختيارات Champion Pick نقاطًا مضاعفة.",
    jp: "チャンピオンピックの選択では、ポイントが倍増する場合があります。"
  },

  // Game Rules - Section 7: Points per bout
  rulesPointsPerBoutTitle: {
    en: "7) Points per bout",
    fr: "7) Points par combat",
    es: "7) Puntos por combate",
    ar: "7) النقاط لكل نزال",
    jp: "7) 試合ごとのポイント"
  },
  rulesPointsPerBoutIntro: {
    en: "Points are calculated per eligible bout based on your pick and the official bout outcome.",
    fr: "Les points sont calculés par combat éligible en fonction de votre choix et du résultat officiel du combat.",
    es: "Los puntos se calculan por combate elegible según tu selección y el resultado oficial del combate.",
    ar: "يتم حساب النقاط لكل نزال مؤهل بناءً على اختيارك ونتيجة النزال الرسمية.",
    jp: "ポイントは、あなたの予想と公式試合結果に基づいて、対象試合ごとに計算されます。"
  },
  rulesBaseWinPointsTitle: {
    en: "7.1 Base win points",
    fr: "7.1 Points de victoire de base",
    es: "7.1 Puntos base de victoria",
    ar: "7.1 نقاط الفوز الأساسية",
    jp: "7.1 基本勝利ポイント"
  },
  rulesBaseWinPointsBullet: {
    en: "Picked fighter wins: <strong>+10</strong>",
    fr: "Le combattant choisi gagne : <strong>+10</strong>",
    es: "El luchador seleccionado gana: <strong>+10</strong>",
    ar: "المقاتل المختار يفوز: <strong>+10</strong>",
    jp: "選択したファイターが勝利：<strong>+10</strong>"
  },
  rulesWinBonusTitle: {
    en: "7.2 Win bonus (how the picked fighter won)",
    fr: "7.2 Bonus de victoire (comment le combattant choisi a gagné)",
    es: "7.2 Bonificación de victoria (cómo ganó el luchador seleccionado)",
    ar: "7.2 مكافأة الفوز (كيف فاز المقاتل المختار)",
    jp: "7.2 勝利ボーナス（選択したファイターの勝ち方）"
  },
  rulesWinBonusIntro: {
    en: "If (and only if) your picked fighter wins:",
    fr: "Si (et seulement si) votre combattant choisi gagne :",
    es: "Si (y solo si) tu luchador seleccionado gana:",
    ar: "إذا (وفقط إذا) فاز مقاتلك المختار:",
    jp: "選択したファイターが勝利した場合（その場合のみ）："
  },
  rulesWinBonusBullet1: {
    en: "Decision win: <strong>+5</strong>",
    fr: "Victoire par décision : <strong>+5</strong>",
    es: "Victoria por decisión: <strong>+5</strong>",
    ar: "فوز بالقرار: <strong>+5</strong>",
    jp: "判定勝ち：<strong>+5</strong>"
  },
  rulesWinBonusBullet2: {
    en: "KO/TKO win: <strong>+20</strong>",
    fr: "Victoire par KO/TKO : <strong>+20</strong>",
    es: "Victoria por KO/TKO: <strong>+20</strong>",
    ar: "فوز بـ KO/TKO: <strong>+20</strong>",
    jp: "KO/TKO勝ち：<strong>+20</strong>"
  },
  rulesWinBonusBullet3: {
    en: "KO/TKO in a specific round: <strong>+30</strong>",
    fr: "KO/TKO dans un round spécifique : <strong>+30</strong>",
    es: "KO/TKO en un round específico: <strong>+30</strong>",
    ar: "KO/TKO في جولة محددة: <strong>+30</strong>",
    jp: "特定ラウンドでのKO/TKO：<strong>+30</strong>"
  },
  rulesLossNoPickTitle: {
    en: "7.3 Loss / no pick",
    fr: "7.3 Défaite / pas de choix",
    es: "7.3 Derrota / sin selección",
    ar: "7.3 الخسارة / عدم الاختيار",
    jp: "7.3 敗北 / 予想なし"
  },
  rulesLossNoPickBullet1: {
    en: "No pick: <strong>0</strong>",
    fr: "Pas de choix : <strong>0</strong>",
    es: "Sin selección: <strong>0</strong>",
    ar: "لا يوجد اختيار: <strong>0</strong>",
    jp: "予想なし：<strong>0</strong>"
  },
  rulesLossNoPickBullet2: {
    en: "Picked fighter loses by decision: <strong>0</strong>",
    fr: "Le combattant choisi perd par décision : <strong>0</strong>",
    es: "El luchador seleccionado pierde por decisión: <strong>0</strong>",
    ar: "المقاتل المختار يخسر بالقرار: <strong>0</strong>",
    jp: "選択したファイターが判定で敗北：<strong>0</strong>"
  },
  rulesLossNoPickBullet3: {
    en: "Picked fighter loses by KO/TKO: <strong>-5</strong>",
    fr: "Le combattant choisi perd par KO/TKO : <strong>-5</strong>",
    es: "El luchador seleccionado pierde por KO/TKO: <strong>-5</strong>",
    ar: "المقاتل المختار يخسر بـ KO/TKO: <strong>-5</strong>",
    jp: "選択したファイターがKO/TKOで敗北：<strong>-5</strong>"
  },
  rulesLossNoPickBullet4: {
    en: "Picked fighter loses by Disqualification (DQ): <strong>-10</strong>",
    fr: "Le combattant choisi perd par disqualification (DQ) : <strong>-10</strong>",
    es: "El luchador seleccionado pierde por descalificación (DQ): <strong>-10</strong>",
    ar: "المقاتل المختار يخسر بالاستبعاد (DQ): <strong>-10</strong>",
    jp: "選択したファイターが失格（DQ）で敗北：<strong>-10</strong>"
  },
  rulesVoidOutcomesTitle: {
    en: "7.4 Void outcomes",
    fr: "7.4 Résultats annulés",
    es: "7.4 Resultados anulados",
    ar: "7.4 النتائج الملغاة",
    jp: "7.4 無効な結果"
  },
  rulesVoidOutcomesIntro: {
    en: "The following outcomes are treated as void and score 0 for all users for that bout:",
    fr: "Les résultats suivants sont traités comme annulés et rapportent 0 point pour tous les utilisateurs pour ce combat :",
    es: "Los siguientes resultados se tratan como anulados y otorgan 0 puntos para todos los usuarios por ese combate:",
    ar: "تُعامل النتائج التالية على أنها ملغاة وتمنح 0 نقطة لجميع المستخدمين لذلك النزال:",
    jp: "以下の結果は無効として扱われ、その試合のすべてのユーザーに0ポイントが付与されます："
  },
  rulesVoidOutcomesBullet1: {
    en: "Draw (any type)",
    fr: "Match nul (tout type)",
    es: "Empate (cualquier tipo)",
    ar: "التعادل (أي نوع)",
    jp: "引き分け（すべてのタイプ）"
  },
  rulesVoidOutcomesBullet2: {
    en: "No Contest",
    fr: "No Contest",
    es: "Sin resultado",
    ar: "بدون نتيجة",
    jp: "ノーコンテスト"
  },
  rulesVoidOutcomesBullet3: {
    en: "Cancelled or postponed bouts (as presented in the Platform)",
    fr: "Combats annulés ou reportés (tels que présentés dans la Plateforme)",
    es: "Combates cancelados o pospuestos (según se presente en la Plataforma)",
    ar: "النزالات الملغاة أو المؤجلة (كما هو معروض في المنصة)",
    jp: "キャンセルまたは延期された試合（プラットフォームに表示されているとおり）"
  },

  // Game Rules - Section 8: Champion Pick (Captain)
  rulesChampionPickCaptainTitle: {
    en: "8) Champion Pick (Captain)",
    fr: "8) Champion Pick (Capitaine)",
    es: "8) Champion Pick (Capitán)",
    ar: "8) اختيار البطل (القائد)",
    jp: "8) チャンピオンピック（キャプテン）"
  },
  rulesSelectingChampionPickTitle: {
    en: "8.1 Selecting a Champion Pick",
    fr: "8.1 Sélectionner un Champion Pick",
    es: "8.1 Seleccionar un Champion Pick",
    ar: "8.1 اختيار اختيار البطل",
    jp: "8.1 チャンピオンピックの選択"
  },
  rulesSelectingChampionPickPara: {
    en: "Each competition window, you may be able to select one bout as your Champion Pick (may also be referred to as captain/crown in the interface), where the feature is available.",
    fr: "À chaque fenêtre de compétition, vous pouvez sélectionner un combat comme votre Champion Pick (peut également être appelé capitaine/couronne dans l'interface), lorsque la fonctionnalité est disponible.",
    es: "En cada ventana de competición, puedes seleccionar un combate como tu Champion Pick (también puede denominarse capitán/corona en la interfaz), cuando la función esté disponible.",
    ar: "في كل فترة منافسة، قد تتمكن من اختيار نزال واحد كاختيار بطلك (قد يُشار إليه أيضًا بالقائد/التاج في الواجهة)، حيثما تكون الميزة متاحة.",
    jp: "各競技期間中、機能が利用可能な場合、1つの試合をチャンピオンピックとして選択できます（インターフェースではキャプテン/クラウンとも呼ばれることがあります）。"
  },
  rulesChampionPickMultiplierTitle: {
    en: "8.2 Champion Pick multiplier",
    fr: "8.2 Multiplicateur Champion Pick",
    es: "8.2 Multiplicador Champion Pick",
    ar: "8.2 مضاعف اختيار البطل",
    jp: "8.2 チャンピオンピック倍率"
  },
  rulesChampionPickMultiplierBullet1: {
    en: "If your Champion Pick wins, the total points for that bout (base + applicable win bonus) are multiplied by <strong>2x</strong>.",
    fr: "Si votre Champion Pick gagne, le total des points pour ce combat (base + bonus de victoire applicable) est multiplié par <strong>2x</strong>.",
    es: "Si tu Champion Pick gana, los puntos totales para ese combate (base + bonificación de victoria aplicable) se multiplican por <strong>2x</strong>.",
    ar: "إذا فاز اختيار البطل الخاص بك، يتم مضاعفة إجمالي النقاط لذلك النزال (الأساس + مكافأة الفوز المعمول بها) بـ <strong>2x</strong>.",
    jp: "チャンピオンピックが勝利した場合、その試合の合計ポイント（基本+該当する勝利ボーナス）は<strong>2倍</strong>になります。"
  },
  rulesChampionPickMultiplierBullet2: {
    en: "If your Champion Pick bout is void (e.g., draw/no contest/cancelled), the Champion Pick produces 0 for that bout (and therefore no multiplier applies).",
    fr: "Si votre combat Champion Pick est annulé (par exemple, nul/no contest/annulé), le Champion Pick produit 0 pour ce combat (et par conséquent aucun multiplicateur ne s'applique).",
    es: "Si tu combate Champion Pick es anulado (por ejemplo, empate/sin resultado/cancelado), el Champion Pick produce 0 para ese combate (y por lo tanto no se aplica ningún multiplicador).",
    ar: "إذا كان نزال اختيار البطل الخاص بك ملغى (على سبيل المثال، تعادل/بدون نتيجة/ملغى)، ينتج اختيار البطل 0 لذلك النزال (وبالتالي لا ينطبق أي مضاعف).",
    jp: "チャンピオンピックの試合が無効（例：引き分け/ノーコンテスト/キャンセル）の場合、チャンピオンピックはその試合で0を生成します（したがって倍率は適用されません）。"
  },

  // Game Rules - Section 6: Champion Pick (alternate - keeping for backward compatibility)
  rulesChampionPickTitle: {
    en: "6) Champion Pick",
    fr: "6) Champion Pick",
    es: "6) Champion Pick",
    ar: "6) اختيار البطل",
    jp: "6) チャンピオンピック"
  },
  rulesChampionPick: {
    en: "Each competition window, you may designate one bout as your \"Champion Pick.\" Points earned from your Champion Pick bout are multiplied. You may only use one Champion Pick per competition window.",
    fr: "À chaque fenêtre de compétition, vous pouvez désigner un combat comme votre \"Champion Pick\". Les points gagnés grâce à votre combat Champion Pick sont multipliés. Vous ne pouvez utiliser qu'un seul Champion Pick par fenêtre de compétition.",
    es: "En cada ventana de competición, puedes designar un combate como tu \"Champion Pick\". Los puntos ganados de tu combate Champion Pick se multiplican. Solo puedes usar un Champion Pick por ventana de competición.",
    ar: "في كل فترة منافسة، يمكنك تعيين نزال واحد كـ \"اختيار البطل\" الخاص بك. يتم مضاعفة النقاط المكتسبة من نزال اختيار البطل الخاص بك. يمكنك استخدام اختيار بطل واحد فقط لكل فترة منافسة.",
    jp: "各競技期間中、1つの試合を「チャンピオンピック」として指定することができます。チャンピオンピックの試合で獲得したポイントは倍増されます。競技期間ごとにチャンピオンピックは1回のみ使用できます。"
  },

  // Game Rules - Section 9: Chips (Boosts)
  rulesChipsBoostsTitle: {
    en: "9) Chips (Boosts)",
    fr: "9) Jetons (Boosts)",
    es: "9) Fichas (Potenciadores)",
    ar: "9) الرقائق (المعززات)",
    jp: "9) チップ（ブースト）"
  },
  rulesChipsBoostsIntro: {
    en: "Chips are optional boosts that change how points are calculated within a competition window.",
    fr: "Les jetons sont des boosts optionnels qui modifient la façon dont les points sont calculés dans une fenêtre de compétition.",
    es: "Las fichas son potenciadores opcionales que cambian cómo se calculan los puntos dentro de una ventana de competición.",
    ar: "الرقائق هي معززات اختيارية تغير طريقة حساب النقاط ضمن فترة المنافسة.",
    jp: "チップは、競技期間内でのポイント計算方法を変更するオプションのブーストです。"
  },
  rulesUsageLimitsStackingTitle: {
    en: "9.1 Usage limits and stacking",
    fr: "9.1 Limites d'utilisation et cumul",
    es: "9.1 Límites de uso y acumulación",
    ar: "9.1 حدود الاستخدام والتراكم",
    jp: "9.1 使用制限と重複"
  },
  rulesUsageBullet1: {
    en: "You may use one (1) chip per user per weekly competition window including any weekly competition window formed by combining multiple calendar weeks as described in section 2.1.",
    fr: "Vous pouvez utiliser un (1) jeton par utilisateur par fenêtre de compétition hebdomadaire, y compris toute fenêtre de compétition hebdomadaire formée en combinant plusieurs semaines civiles comme décrit à la section 2.1.",
    es: "Puedes usar una (1) ficha por usuario por ventana de competición semanal, incluyendo cualquier ventana de competición semanal formada al combinar múltiples semanas calendario como se describe en la sección 2.1.",
    ar: "يمكنك استخدام رقاقة واحدة (1) لكل مستخدم لكل فترة منافسة أسبوعية بما في ذلك أي فترة منافسة أسبوعية تم تشكيلها عن طريق دمج عدة أسابيع تقويمية كما هو موضح في القسم 2.1.",
    jp: "セクション2.1に記載されている複数の暦週を組み合わせて形成された週間競技期間を含む、週間競技期間ごとにユーザーあたり1つのチップを使用できます。"
  },
  rulesUsageBullet2: {
    en: "Chips cannot be stacked (you cannot use more than one chip in the same window).",
    fr: "Les jetons ne peuvent pas être cumulés (vous ne pouvez pas utiliser plus d'un jeton dans la même fenêtre).",
    es: "Las fichas no se pueden acumular (no puedes usar más de una ficha en la misma ventana).",
    ar: "لا يمكن تراكم الرقائق (لا يمكنك استخدام أكثر من رقاقة واحدة في نفس الفترة).",
    jp: "チップは重複できません（同じ期間内に複数のチップを使用することはできません）。"
  },
  rulesUsageBullet3: {
    en: "Chip availability are limited (once per quarter), and availability will be shown in-product.",
    fr: "La disponibilité des jetons est limitée (une fois par trimestre), et la disponibilité sera affichée dans le produit.",
    es: "La disponibilidad de fichas es limitada (una vez por trimestre), y la disponibilidad se mostrará en el producto.",
    ar: "توفر الرقائق محدود (مرة واحدة في الربع)، وسيتم عرض التوفر في المنتج.",
    jp: "チップの利用可能性は制限されており（四半期に1回）、利用可能性は製品内で表示されます。"
  },
  rulesUsageBullet4: {
    en: "Chips must be activated before the scheduled start time of the first bout in the relevant weekly competition window. Once the first bout has started, no chip may be activated for that competition window.",
    fr: "Les jetons doivent être activés avant l'heure de début prévue du premier combat dans la fenêtre de compétition hebdomadaire concernée. Une fois que le premier combat a commencé, aucun jeton ne peut être activé pour cette fenêtre de compétition.",
    es: "Las fichas deben activarse antes de la hora de inicio programada del primer combate en la ventana de competición semanal relevante. Una vez que ha comenzado el primer combate, no se puede activar ninguna ficha para esa ventana de competición.",
    ar: "يجب تفعيل الرقائق قبل وقت البدء المجدول للنزال الأول في فترة المنافسة الأسبوعية ذات الصلة. بمجرد بدء النزال الأول، لا يمكن تفعيل أي رقاقة لتلك فترة المنافسة.",
    jp: "チップは、該当する週間競技期間の最初の試合の予定開始時刻の前に有効化する必要があります。最初の試合が開始されると、その競技期間のチップを有効化することはできません。"
  },
  rulesUsageBullet5: {
    en: "Any bout that is void for Fantasy scoring (including due to a draw, no contest, cancellation, or postponement) has no effect on chip scoring or chip-related point calculations.",
    fr: "Tout combat qui est annulé pour le score Fantasy (y compris en raison d'un nul, d'un no contest, d'une annulation ou d'un report) n'a aucun effet sur le score des jetons ou les calculs de points liés aux jetons.",
    es: "Cualquier combate que sea anulado para la puntuación de Fantasy (incluyendo debido a un empate, sin resultado, cancelación o aplazamiento) no tiene efecto en la puntuación de fichas o cálculos de puntos relacionados con fichas.",
    ar: "أي نزال يكون ملغى لتسجيل Fantasy (بما في ذلك بسبب التعادل أو بدون نتيجة أو الإلغاء أو التأجيل) ليس له تأثير على تسجيل الرقائق أو حسابات النقاط المتعلقة بالرقائق.",
    jp: "Fantasyスコアリングにおいて無効な試合（引き分け、ノーコンテスト、キャンセル、延期による場合を含む）は、チップスコアリングやチップ関連のポイント計算に影響しません。"
  },
  rulesChipTypesTitle: {
    en: "9.2 Chip types",
    fr: "9.2 Types de jetons",
    es: "9.2 Tipos de fichas",
    ar: "9.2 أنواع الرقائق",
    jp: "9.2 チップの種類"
  },
  rulesKoFrenzyTitle: {
    en: "KO Frenzy",
    fr: "KO Frenzy",
    es: "KO Frenzy",
    ar: "جنون الضربة القاضية",
    jp: "KO フレンジー"
  },
  rulesKoFrenzyEffect: {
    en: "<strong>Effect:</strong> For any bout in the competition window that ends by KO or TKO, the points you earn for that bout are doubled.",
    fr: "<strong>Effet :</strong> Pour tout combat dans la fenêtre de compétition qui se termine par KO ou TKO, les points que vous gagnez pour ce combat sont doublés.",
    es: "<strong>Efecto:</strong> Para cualquier combate en la ventana de competición que termine por KO o TKO, los puntos que ganas por ese combate se duplican.",
    ar: "<strong>التأثير:</strong> لأي نزال في فترة المنافسة ينتهي بـ KO أو TKO، يتم مضاعفة النقاط التي تكسبها لذلك النزال.",
    jp: "<strong>効果:</strong> 競技期間内でKOまたはTKOで終了する試合について、その試合で獲得するポイントが2倍になります。"
  },
  rulesKoFrenzyImpact: {
    en: "<strong>Points impact:</strong> 2x points for all KO/TKO outcomes in that window, regardless of the method you selected for that bout.",
    fr: "<strong>Impact sur les points :</strong> 2x points pour tous les résultats KO/TKO dans cette fenêtre, quelle que soit la méthode que vous avez sélectionnée pour ce combat.",
    es: "<strong>Impacto en puntos:</strong> 2x puntos para todos los resultados de KO/TKO en esa ventana, independientemente del método que seleccionaste para ese combate.",
    ar: "<strong>تأثير النقاط:</strong> ضعف النقاط لجميع نتائج KO/TKO في تلك الفترة، بغض النظر عن الطريقة التي اخترتها لذلك النزال.",
    jp: "<strong>ポイントへの影響:</strong> その期間内のすべてのKO/TKO結果について、その試合で選択した方法に関係なく2倍のポイント。"
  },
  rulesRingChampionBeltTitle: {
    en: "Ring Champion Belt",
    fr: "Ceinture Ring Champion",
    es: "Cinturón Ring Champion",
    ar: "حزام Ring Champion",
    jp: "Ring Champion ベルト"
  },
  rulesRingChampionBeltEffect: {
    en: "<strong>Effect:</strong> Supercharges your Champion Pick.",
    fr: "<strong>Effet :</strong> Surcharge votre Champion Pick.",
    es: "<strong>Efecto:</strong> Supercarga tu Champion Pick.",
    ar: "<strong>التأثير:</strong> يعزز اختيار البطل الخاص بك.",
    jp: "<strong>効果:</strong> チャンピオンピックを強化します。"
  },
  rulesRingChampionBeltImpact: {
    en: "<strong>Points impact:</strong> Your Champion Pick becomes 4x (instead of 2x) for that window.",
    fr: "<strong>Impact sur les points :</strong> Votre Champion Pick devient 4x (au lieu de 2x) pour cette fenêtre.",
    es: "<strong>Impacto en puntos:</strong> Tu Champion Pick se convierte en 4x (en lugar de 2x) para esa ventana.",
    ar: "<strong>تأثير النقاط:</strong> يصبح اختيار البطل الخاص بك 4 أضعاف (بدلاً من ضعفين) لتلك الفترة.",
    jp: "<strong>ポイントへの影響:</strong> その期間のチャンピオンピックが4倍（2倍ではなく）になります。"
  },
  rulesGoTheDistanceTitle: {
    en: "Go the Distance",
    fr: "Aller la distance",
    es: "Ir la distancia",
    ar: "الذهاب للمسافة",
    jp: "ゴー・ザ・ディスタンス"
  },
  rulesGoTheDistanceEffect: {
    en: "<strong>Effect:</strong> Any fight that ends by decision scores double points for that bout.",
    fr: "<strong>Effet :</strong> Tout combat qui se termine par décision rapporte le double de points pour ce combat.",
    es: "<strong>Efecto:</strong> Cualquier pelea que termine por decisión otorga el doble de puntos para ese combate.",
    ar: "<strong>التأثير:</strong> أي نزال ينتهي بقرار يحصل على نقاط مضاعفة لذلك النزال.",
    jp: "<strong>効果:</strong> 判定で終了する試合は、その試合で2倍のポイントを獲得します。"
  },
  rulesGoTheDistanceImpact: {
    en: "<strong>Points impact:</strong> 2x points for decision outcomes (the points you earn for that bout are doubled when the official result is a decision). The Go the Distance multiplier is based on the official bout result, not the method you selected. It doubles only the points you earned for that bout.",
    fr: "<strong>Impact sur les points :</strong> 2x points pour les résultats par décision (les points que vous gagnez pour ce combat sont doublés lorsque le résultat officiel est une décision). Le multiplicateur Aller la distance est basé sur le résultat officiel du combat, et non sur la méthode que vous avez sélectionnée. Il ne double que les points que vous avez gagnés pour ce combat.",
    es: "<strong>Impacto en puntos:</strong> 2x puntos para resultados por decisión (los puntos que ganas por ese combate se duplican cuando el resultado oficial es una decisión). El multiplicador Ir la distancia se basa en el resultado oficial del combate, no en el método que seleccionaste. Solo duplica los puntos que ganaste por ese combate.",
    ar: "<strong>تأثير النقاط:</strong> ضعف النقاط لنتائج القرار (يتم مضاعفة النقاط التي تكسبها لذلك النزال عندما تكون النتيجة الرسمية قرارًا). يستند مضاعف الذهاب للمسافة إلى نتيجة النزال الرسمية، وليس الطريقة التي اخترتها. يضاعف فقط النقاط التي كسبتها لذلك النزال.",
    jp: "<strong>ポイントへの影響:</strong> 判定結果の場合は2倍のポイント（公式結果が判定の場合、その試合で獲得したポイントが2倍になります）。ゴー・ザ・ディスタンス倍率は、選択した方法ではなく、公式試合結果に基づきます。その試合で獲得したポイントのみを2倍にします。"
  },
  rulesGoTheDistanceExample: {
    en: "<strong>Example:</strong> if you picked the winning fighter but selected a KO/TKO method and the bout goes to decision, you still receive 2x your base win points (i.e., 2x +10).",
    fr: "<strong>Exemple :</strong> si vous avez choisi le combattant gagnant mais sélectionné une méthode KO/TKO et que le combat va à la décision, vous recevez toujours 2x vos points de victoire de base (c'est-à-dire 2x +10).",
    es: "<strong>Ejemplo:</strong> si elegiste al luchador ganador pero seleccionaste un método KO/TKO y el combate va a decisión, aún recibes 2x tus puntos de victoria base (es decir, 2x +10).",
    ar: "<strong>مثال:</strong> إذا اخترت المقاتل الفائز لكن اخترت طريقة KO/TKO وذهب النزال إلى القرار، فستظل تحصل على ضعف نقاط الفوز الأساسية (أي 2x +10).",
    jp: "<strong>例:</strong> 勝利ファイターを選択したが、KO/TKO方法を選択し、試合が判定になった場合でも、基本勝利ポイントの2倍（つまり2x +10）を受け取ります。"
  },
  rulesGoTheDistanceInteraction: {
    en: "<strong>Interaction with Decision win bonus:</strong> If your picked fighter wins by decision, the Decision win bonus (+5) is applied first (where applicable), and the Go the Distance chip then doubles the total points earned for that bout.",
    fr: "<strong>Interaction avec le bonus de victoire par décision :</strong> Si votre combattant choisi gagne par décision, le bonus de victoire par décision (+5) est appliqué en premier (le cas échéant), et le jeton Aller la distance double ensuite le total des points gagnés pour ce combat.",
    es: "<strong>Interacción con bonificación de victoria por decisión:</strong> Si tu luchador seleccionado gana por decisión, la bonificación de victoria por decisión (+5) se aplica primero (cuando corresponda), y luego la ficha Ir la distancia duplica los puntos totales ganados por ese combate.",
    ar: "<strong>التفاعل مع مكافأة الفوز بالقرار:</strong> إذا فاز مقاتلك المختار بالقرار، يتم تطبيق مكافأة الفوز بالقرار (+5) أولاً (حيثما كان ذلك ممكنًا)، ثم تضاعف رقاقة الذهاب للمسافة إجمالي النقاط المكتسبة لذلك النزال.",
    jp: "<strong>判定勝利ボーナスとの相互作用:</strong> 選択したファイターが判定で勝利した場合、判定勝利ボーナス（+5）が最初に適用され（該当する場合）、その後ゴー・ザ・ディスタンスチップがその試合で獲得した合計ポイントを2倍にします。"
  },
  rulesChipInterpretationTitle: {
    en: "9.3 Chip interpretation",
    fr: "9.3 Interprétation des jetons",
    es: "9.3 Interpretación de fichas",
    ar: "9.3 تفسير الرقائق",
    jp: "9.3 チップの解釈"
  },
  rulesChipInterpretationPara: {
    en: "Where an edge case arises (for example, unusual stoppage rulings or timing anomalies), Ring will apply the chip logic as reasonably reflected by the official result and round/time recorded and as implemented in the Platform.",
    fr: "Lorsqu'un cas limite survient (par exemple, des arrêts inhabituels ou des anomalies de timing), Ring appliquera la logique des jetons telle que raisonnablement reflétée par le résultat officiel et le round/temps enregistré et tel qu'implémenté dans la Plateforme.",
    es: "Cuando surja un caso límite (por ejemplo, fallos de detención inusuales o anomalías de tiempo), Ring aplicará la lógica de fichas según se refleje razonablemente en el resultado oficial y el round/tiempo registrado y según se implemente en la Plataforma.",
    ar: "عندما تنشأ حالة حدية (على سبيل المثال، قرارات إيقاف غير عادية أو شذوذات في التوقيت)، ستطبق Ring منطق الرقاقة كما ينعكس بشكل معقول من خلال النتيجة الرسمية والجولة/الوقت المسجل وكما هو منفذ في المنصة.",
    jp: "エッジケースが発生した場合（例えば、通常とは異なるストップの判定やタイミングの異常など）、Ringは、公式結果と記録されたラウンド/時間によって合理的に反映され、プラットフォームで実装されているとおりにチップロジックを適用します。"
  },

  // Game Rules - Section 7: Chips and Boosters (alternate - keeping for backward compatibility)
  rulesChipsTitle: {
    en: "7) Chips and Boosters",
    fr: "7) Jetons et Boosters",
    es: "7) Fichas y Potenciadores",
    ar: "7) الرقائق والمعززات",
    jp: "7) チップとブースター"
  },
  rulesChipsIntro: {
    en: "Fantasy may offer special chips or boosters that provide strategic advantages. These may include:",
    fr: "Fantasy peut offrir des jetons ou boosters spéciaux qui offrent des avantages stratégiques. Ceux-ci peuvent inclure :",
    es: "Fantasy puede ofrecer fichas o potenciadores especiales que proporcionan ventajas estratégicas. Estos pueden incluir:",
    ar: "قد تقدم Fantasy رقائق أو معززات خاصة توفر مزايا استراتيجية. قد تشمل هذه:",
    jp: "Fantasyでは戦略的優位性をもたらす特別なチップやブースターが提供される場合があります。これらには以下が含まれます："
  },
  rulesDoubleChampion: {
    en: "Double Champion: Use two Champion Picks in a single competition window.",
    fr: "Double Champion : Utilisez deux Champion Picks dans une seule fenêtre de compétition.",
    es: "Doble Campeón: Usa dos Champion Picks en una sola ventana de competición.",
    ar: "بطل مزدوج: استخدم اختيارين للبطل في فترة منافسة واحدة.",
    jp: "ダブルチャンピオン：1つの競技期間で2つのチャンピオンピックを使用します。"
  },
  rulesSafePick: {
    en: "Safe Pick: Protect one pick from losing points if incorrect.",
    fr: "Safe Pick : Protégez un choix de la perte de points s'il est incorrect.",
    es: "Safe Pick: Protege una selección de perder puntos si es incorrecta.",
    ar: "الاختيار الآمن: احمِ اختيارًا واحدًا من خسارة النقاط إذا كان غير صحيح.",
    jp: "セーフピック：不正解でも1つの予想がポイントを失うことを防ぎます。"
  },
  rulesPointMultiplier: {
    en: "Point Multiplier: Multiply all points earned in a competition window.",
    fr: "Multiplicateur de points : Multipliez tous les points gagnés dans une fenêtre de compétition.",
    es: "Multiplicador de puntos: Multiplica todos los puntos ganados en una ventana de competición.",
    ar: "مضاعف النقاط: ضاعف جميع النقاط المكتسبة في فترة منافسة.",
    jp: "ポイント倍率：競技期間内に獲得したすべてのポイントを倍増します。"
  },
  rulesChipsNote: {
    en: "Chip availability and rules may vary by season or competition period.",
    fr: "La disponibilité des jetons et les règles peuvent varier selon la saison ou la période de compétition.",
    es: "La disponibilidad de fichas y las reglas pueden variar según la temporada o el período de competición.",
    ar: "قد يختلف توفر الرقائق والقواعد حسب الموسم أو فترة المنافسة.",
    jp: "チップの利用可能性とルールは、シーズンや競技期間によって異なる場合があります。"
  },

  // Game Rules - Section 10: Leaderboards and tie-breakers
  rulesLeaderboardsTiebreakersTitle: {
    en: "10) Leaderboards and tie-breakers",
    fr: "10) Classements et départages",
    es: "10) Clasificaciones y desempates",
    ar: "10) لوحات الصدارة وقواعد الفصل",
    jp: "10) リーダーボードとタイブレーカー"
  },
  rulesLeaderboardsSectionTitle: {
    en: "10.1 Leaderboards",
    fr: "10.1 Classements",
    es: "10.1 Clasificaciones",
    ar: "10.1 لوحات الصدارة",
    jp: "10.1 リーダーボード"
  },
  rulesLeaderboardsPara: {
    en: "The Game provides Quarterly and Annual leaderboards, which reflect the cumulative points earned from all settled competition windows falling within the relevant quarter or annual period. Although points are earned within individual weekly competition windows (where offered), there is no standalone weekly leaderboard. Weekly results contribute only to the applicable Quarterly and Annual leaderboards and are not ranked or displayed separately.",
    fr: "Le jeu fournit des classements trimestriels et annuels, qui reflètent les points cumulés gagnés de toutes les fenêtres de compétition réglées tombant dans le trimestre ou la période annuelle concernée. Bien que les points soient gagnés dans des fenêtres de compétition hebdomadaires individuelles (lorsqu'elles sont proposées), il n'y a pas de classement hebdomadaire autonome. Les résultats hebdomadaires ne contribuent qu'aux classements trimestriels et annuels applicables et ne sont pas classés ou affichés séparément.",
    es: "El juego proporciona clasificaciones trimestrales y anuales, que reflejan los puntos acumulativos ganados de todas las ventanas de competición resueltas que caen dentro del trimestre o período anual relevante. Aunque los puntos se ganan dentro de ventanas de competición semanales individuales (donde se ofrecen), no hay una clasificación semanal independiente. Los resultados semanales solo contribuyen a las clasificaciones trimestrales y anuales aplicables y no se clasifican ni se muestran por separado.",
    ar: "توفر اللعبة لوحات صدارة فصلية وسنوية، والتي تعكس النقاط التراكمية المكتسبة من جميع فترات المنافسة المحسومة التي تقع ضمن الربع أو الفترة السنوية ذات الصلة. على الرغم من أن النقاط تُكتسب ضمن فترات منافسة أسبوعية فردية (حيثما كانت متاحة)، لا توجد لوحة صدارة أسبوعية مستقلة. تساهم النتائج الأسبوعية فقط في لوحات الصدارة الفصلية والسنوية المعمول بها ولا يتم تصنيفها أو عرضها بشكل منفصل.",
    jp: "このゲームは四半期および年間のリーダーボードを提供しており、関連する四半期または年間期間内で終了したすべての競技期間から獲得した累積ポイントが反映されます。ポイントは個別の週間競技期間内で獲得されますが（提供されている場合）、独立した週間リーダーボードはありません。週間結果は該当する四半期および年間のリーダーボードにのみ寄与し、別途ランク付けまたは表示されることはありません。"
  },
  rulesTiebreakersSectionTitle: {
    en: "10.2 Tie-breakers",
    fr: "10.2 Départages",
    es: "10.2 Desempates",
    ar: "10.2 قواعد الفصل بين المتعادلين",
    jp: "10.2 タイブレーカー"
  },
  rulesTiebreakersIntro: {
    en: "If two or more users are tied on total points for a ranked or prize position, Ring may apply the following tie-breakers in order, to the extent applicable:",
    fr: "Si deux utilisateurs ou plus sont à égalité sur le total des points pour une position classée ou un prix, Ring peut appliquer les départages suivants dans l'ordre, dans la mesure applicable :",
    es: "Si dos o más usuarios están empatados en puntos totales para una posición clasificada o de premio, Ring puede aplicar los siguientes desempates en orden, en la medida aplicable:",
    ar: "إذا كان مستخدمان أو أكثر متعادلين في إجمالي النقاط لمركز مرتب أو موضع جائزة، فقد تطبق Ring قواعد الفصل التالية بالترتيب، بالقدر المعمول به:",
    jp: "ランク付けまたは賞品の位置で2人以上のユーザーが合計ポイントで同点の場合、Ringは適用可能な範囲で以下のタイブレーカーを順番に適用する場合があります："
  },
  rulesTiebreakerItem1: {
    en: "Most winning picks during the relevant competition period;",
    fr: "Le plus de choix gagnants pendant la période de compétition concernée ;",
    es: "Más selecciones ganadoras durante el período de competición relevante;",
    ar: "أكثر الاختيارات الفائزة خلال فترة المنافسة ذات الصلة؛",
    jp: "該当する競技期間中の勝利予想数が最も多い方；"
  },
  rulesTiebreakerItem2: {
    en: "Most total bouts picked during the relevant competition period;",
    fr: "Le plus de combats au total choisis pendant la période de compétition concernée ;",
    es: "Más combates totales seleccionados durante el período de competición relevante;",
    ar: "أكثر إجمالي النزالات المختارة خلال فترة المنافسة ذات الصلة؛",
    jp: "該当する競技期間中に予想した試合の総数が最も多い方；"
  },
  rulesTiebreakerItem3: {
    en: "Earliest timestamp of picks submission for that competition period; and if still tied,",
    fr: "Horodatage le plus ancien de soumission des choix pour cette période de compétition ; et si toujours à égalité,",
    es: "Marca de tiempo más temprana de envío de selecciones para ese período de competición; y si aún están empatados,",
    ar: "أقدم طابع زمني لتقديم الاختيارات لتلك فترة المنافسة؛ وإذا كان لا يزال متعادلاً،",
    jp: "その競技期間の予想提出時刻が最も早い方；それでも同点の場合、"
  },
  rulesTiebreakerItem4: {
    en: "Random selection using a transparent method.",
    fr: "Sélection aléatoire utilisant une méthode transparente.",
    es: "Selección aleatoria usando un método transparente.",
    ar: "اختيار عشوائي باستخدام طريقة شفافة.",
    jp: "透明な方法を使用したランダム選択。"
  },
  rulesTiebreakersClosing: {
    en: "Where a particular tie-breaker would not meaningfully differentiate tied users, Ring may skip that step and apply the next tie-breaker. Ring's determination is final for Fantasy purposes.",
    fr: "Lorsqu'un départage particulier ne différencierait pas de manière significative les utilisateurs à égalité, Ring peut sauter cette étape et appliquer le départage suivant. La détermination de Ring est définitive aux fins de Fantasy.",
    es: "Cuando un desempate particular no diferenciaría significativamente a los usuarios empatados, Ring puede omitir ese paso y aplicar el siguiente desempate. La determinación de Ring es final para los propósitos de Fantasy.",
    ar: "عندما لا تميز قاعدة فصل معينة بشكل ذي مغزى بين المستخدمين المتعادلين، قد تتخطى Ring تلك الخطوة وتطبق قاعدة الفصل التالية. قرار Ring نهائي لأغراض Fantasy.",
    jp: "特定のタイブレーカーが同点のユーザーを有意義に区別できない場合、Ringはそのステップをスキップして次のタイブレーカーを適用する場合があります。Ringの決定はFantasyの目的において最終的なものです。"
  },

  // Game Rules - Section 11: Definitions and clarifications
  rulesDefinitionsClarificationsTitle: {
    en: "11) Definitions and clarifications (for gameplay purposes)",
    fr: "11) Définitions et clarifications (à des fins de gameplay)",
    es: "11) Definiciones y aclaraciones (para fines de jugabilidad)",
    ar: "11) التعريفات والتوضيحات (لأغراض اللعب)",
    jp: "11) 定義と明確化（ゲームプレイ目的）"
  },
  rulesDefinitionsIntro1: {
    en: "This section is provided to help explain how common terms are applied for Fantasy scoring and gameplay and is intended as guidance only.",
    fr: "Cette section est fournie pour aider à expliquer comment les termes courants sont appliqués pour le score et le gameplay de Fantasy et est destinée uniquement à titre indicatif.",
    es: "Esta sección se proporciona para ayudar a explicar cómo se aplican los términos comunes para la puntuación y jugabilidad de Fantasy y está destinada solo como guía.",
    ar: "يتم توفير هذا القسم للمساعدة في شرح كيفية تطبيق المصطلحات الشائعة لتسجيل Fantasy واللعب وهو مقصود كدليل فقط.",
    jp: "このセクションは、Fantasyのスコアリングとゲームプレイに一般的な用語がどのように適用されるかを説明するために提供されており、ガイダンスとしてのみ意図されています。"
  },
  rulesDefinitionsIntro2: {
    en: "Fantasy scoring is based on official bout outcomes as announced in-venue or by the relevant governing body and as applied within the Platform. Where there is any inconsistency between a general explanation in this section and the outcome reflected in the Platform or the scoring applied by Ring, the Platform presentation and Ring's scoring determination will apply for Fantasy purposes.",
    fr: "Le score Fantasy est basé sur les résultats officiels des combats tels qu'annoncés sur place ou par l'organisme directeur concerné et tels qu'appliqués dans la Plateforme. En cas d'incohérence entre une explication générale dans cette section et le résultat reflété dans la Plateforme ou le score appliqué par Ring, la présentation de la Plateforme et la détermination du score de Ring s'appliqueront aux fins de Fantasy.",
    es: "La puntuación de Fantasy se basa en los resultados oficiales de los combates según lo anunciado en el lugar o por el órgano rector relevante y según se aplica dentro de la Plataforma. Cuando haya alguna inconsistencia entre una explicación general en esta sección y el resultado reflejado en la Plataforma o la puntuación aplicada por Ring, la presentación de la Plataforma y la determinación de puntuación de Ring se aplicarán para los propósitos de Fantasy.",
    ar: "يستند تسجيل Fantasy إلى نتائج النزالات الرسمية كما تم الإعلان عنها في المكان أو من قبل الهيئة الحاكمة ذات الصلة وكما هو مطبق في المنصة. عندما يكون هناك أي تناقض بين شرح عام في هذا القسم والنتيجة المنعكسة في المنصة أو التسجيل المطبق من قبل Ring، سيتم تطبيق عرض المنصة وتحديد تسجيل Ring لأغراض Fantasy.",
    jp: "Fantasyスコアリングは、会場内または関連統括団体によって発表され、プラットフォーム内で適用される公式試合結果に基づいています。このセクションの一般的な説明とプラットフォームに反映されている結果またはRingによって適用されたスコアリングとの間に不一致がある場合、プラットフォームの表示とRingのスコアリング決定がFantasyの目的に適用されます。"
  },
  rulesDefinitionsIntro3: {
    en: "These definitions do not replace, reinterpret, or override official boxing rules, commission determinations, or Fantasy scoring as applied in-product.",
    fr: "Ces définitions ne remplacent pas, ne réinterprètent pas et ne remplacent pas les règles officielles de boxe, les déterminations de commission ou le score Fantasy tel qu'appliqué dans le produit.",
    es: "Estas definiciones no reemplazan, reinterpretan ni anulan las reglas oficiales de boxeo, las determinaciones de comisiones o la puntuación de Fantasy según se aplica en el producto.",
    ar: "هذه التعريفات لا تحل محل أو تعيد تفسير أو تلغي قواعد الملاكمة الرسمية أو قرارات اللجان أو تسجيل Fantasy كما هو مطبق في المنتج.",
    jp: "これらの定義は、公式ボクシングルール、コミッションの決定、または製品内で適用されるFantasyスコアリングを置き換えたり、再解釈したり、無効にしたりするものではありません。"
  },
  rulesKoTkoDefinitionTitle: {
    en: "11.1 KO / TKO",
    fr: "11.1 KO / TKO",
    es: "11.1 KO / TKO",
    ar: "11.1 KO / TKO",
    jp: "11.1 KO / TKO"
  },
  rulesKoTkoBullet1: {
    en: "KO (Knockout) and TKO (Technical Knockout) mean a bout ending by knockout or technical knockout as officially announced by the relevant commission or governing body.",
    fr: "KO (Knockout) et TKO (Technical Knockout) signifient un combat se terminant par knockout ou knockout technique tel qu'officiellement annoncé par la commission ou l'organisme directeur concerné.",
    es: "KO (Knockout) y TKO (Knockout Técnico) significan un combate que termina por nocaut o nocaut técnico según lo anunciado oficialmente por la comisión u órgano rector relevante.",
    ar: "KO (الضربة القاضية) و TKO (الضربة القاضية الفنية) تعني نزال ينتهي بالضربة القاضية أو الضربة القاضية الفنية كما تم الإعلان عنها رسميًا من قبل اللجنة أو الهيئة الحاكمة ذات الصلة.",
    jp: "KO（ノックアウト）およびTKO（テクニカルノックアウト）は、関連するコミッションまたは統括団体によって正式に発表された、ノックアウトまたはテクニカルノックアウトによる試合の終了を意味します。"
  },
  rulesKoTkoBullet2: {
    en: "For Fantasy purposes, KO and TKO are treated the same unless otherwise stated.",
    fr: "Aux fins de Fantasy, KO et TKO sont traités de la même manière sauf indication contraire.",
    es: "Para los propósitos de Fantasy, KO y TKO se tratan igual a menos que se indique lo contrario.",
    ar: "لأغراض Fantasy، تُعامل KO و TKO بنفس الطريقة ما لم يُذكر خلاف ذلك.",
    jp: "Fantasyの目的上、特に明記されていない限り、KOとTKOは同じように扱われます。"
  },
  rulesKoTkoBullet3: {
    en: "Corner stoppages, referee stoppages, and doctor stoppages are treated as TKO.",
    fr: "Les arrêts du coin, les arrêts de l'arbitre et les arrêts du médecin sont traités comme TKO.",
    es: "Las detenciones del esquinero, las detenciones del árbitro y las detenciones del médico se tratan como TKO.",
    ar: "يتم التعامل مع توقفات الزاوية وتوقفات الحكم وتوقفات الطبيب على أنها TKO.",
    jp: "コーナーストップ、レフェリーストップ、ドクターストップはTKOとして扱われます。"
  },
  rulesDecisionDefinitionTitle: {
    en: "11.2 Decision",
    fr: "11.2 Décision",
    es: "11.2 Decisión",
    ar: "11.2 القرار",
    jp: "11.2 判定"
  },
  rulesDecisionBullet1: {
    en: "Decision win means a bout that goes to the judges' scorecards and is declared a win by unanimous, split, or majority decision (including any technical decision where applicable).",
    fr: "La victoire par décision signifie un combat qui va aux cartes de pointage des juges et est déclaré une victoire par décision unanime, partagée ou majoritaire (y compris toute décision technique le cas échéant).",
    es: "Victoria por decisión significa un combate que va a las tarjetas de puntuación de los jueces y se declara una victoria por decisión unánime, dividida o mayoritaria (incluyendo cualquier decisión técnica cuando corresponda).",
    ar: "فوز بالقرار يعني نزال يذهب إلى بطاقات تسجيل الحكام ويُعلن فوزًا بقرار إجماعي أو منقسم أو بالأغلبية (بما في ذلك أي قرار فني حيثما كان ذلك ممكنًا).",
    jp: "判定勝ちとは、ジャッジのスコアカードに委ねられ、全員一致判定、スプリット判定、またはマジョリティ判定（該当する場合はテクニカル判定を含む）による勝利が宣言される試合を意味します。"
  },
  rulesDecisionBullet2: {
    en: "A decision win qualifies for the Decision win bonus (+5) where applicable.",
    fr: "Une victoire par décision donne droit au bonus de victoire par décision (+5) le cas échéant.",
    es: "Una victoria por decisión califica para la bonificación de victoria por decisión (+5) cuando corresponda.",
    ar: "الفوز بالقرار يؤهل لمكافأة الفوز بالقرار (+5) حيثما كان ذلك ممكنًا.",
    jp: "判定勝ちは、該当する場合、判定勝利ボーナス（+5）の対象となります。"
  },
  rulesDisqualificationDefinitionTitle: {
    en: "11.3 Disqualification (DQ)",
    fr: "11.3 Disqualification (DQ)",
    es: "11.3 Descalificación (DQ)",
    ar: "11.3 الاستبعاد (DQ)",
    jp: "11.3 失格（DQ）"
  },
  rulesDisqualificationBullet1: {
    en: "Disqualification (DQ) means a bout where a fighter is officially disqualified by the referee or commission.",
    fr: "La disqualification (DQ) signifie un combat où un combattant est officiellement disqualifié par l'arbitre ou la commission.",
    es: "Descalificación (DQ) significa un combate donde un luchador es oficialmente descalificado por el árbitro o la comisión.",
    ar: "الاستبعاد (DQ) يعني نزال حيث يتم استبعاد مقاتل رسميًا من قبل الحكم أو اللجنة.",
    jp: "失格（DQ）とは、レフェリーまたはコミッションによってファイターが正式に失格となる試合を意味します。"
  },
  rulesDisqualificationBullet2: {
    en: "If the fighter you picked loses by DQ, the applicable DQ loss penalty (-10) applies.",
    fr: "Si le combattant que vous avez choisi perd par DQ, la pénalité de perte DQ applicable (-10) s'applique.",
    es: "Si el luchador que seleccionaste pierde por DQ, se aplica la penalización de pérdida por DQ aplicable (-10).",
    ar: "إذا خسر المقاتل الذي اخترته بـ DQ، تنطبق عقوبة خسارة DQ المعمول بها (-10).",
    jp: "選択したファイターがDQで負けた場合、該当するDQ敗北ペナルティ（-10）が適用されます。"
  },
  rulesDisqualificationBullet3: {
    en: "If the opponent is disqualified and your picked fighter is declared the winner, the result is treated as a win, and Fantasy points are awarded accordingly.",
    fr: "Si l'adversaire est disqualifié et que votre combattant choisi est déclaré vainqueur, le résultat est traité comme une victoire et des points Fantasy sont attribués en conséquence.",
    es: "Si el oponente es descalificado y tu luchador seleccionado es declarado ganador, el resultado se trata como una victoria y se otorgan puntos de Fantasy en consecuencia.",
    ar: "إذا تم استبعاد الخصم وتم إعلان مقاتلك المختار الفائز، يُعامل النتيجة كفوز، وتُمنح نقاط Fantasy وفقًا لذلك.",
    jp: "対戦相手が失格となり、選択したファイターが勝者と宣言された場合、結果は勝利として扱われ、それに応じてFantasyポイントが授与されます。"
  },
  rulesDrawDefinitionTitle: {
    en: "11.4 Draw",
    fr: "11.4 Match nul",
    es: "11.4 Empate",
    ar: "11.4 التعادل",
    jp: "11.4 引き分け"
  },
  rulesDrawBullet1: {
    en: "Draw includes unanimous draw, split draw, and majority draw.",
    fr: "Le match nul inclut le nul unanime, le nul partagé et le nul majoritaire.",
    es: "El empate incluye empate unánime, empate dividido y empate mayoritario.",
    ar: "يشمل التعادل التعادل الإجماعي والتعادل المنقسم والتعادل بالأغلبية.",
    jp: "引き分けには、全員一致の引き分け、スプリットドロー、マジョリティドローが含まれます。"
  },
  rulesDrawBullet2: {
    en: "All draws are treated as void for Fantasy scoring, and all users score 0 points for that bout, regardless of pick.",
    fr: "Tous les matchs nuls sont traités comme annulés pour le score Fantasy, et tous les utilisateurs marquent 0 point pour ce combat, quel que soit le choix.",
    es: "Todos los empates se tratan como anulados para la puntuación de Fantasy, y todos los usuarios obtienen 0 puntos por ese combate, independientemente de la selección.",
    ar: "تُعامل جميع التعادلات على أنها ملغاة لتسجيل Fantasy، ويحصل جميع المستخدمين على 0 نقطة لذلك النزال، بغض النظر عن الاختيار.",
    jp: "すべての引き分けはFantasyスコアリングにおいて無効として扱われ、予想に関係なく、すべてのユーザーはその試合で0ポイントになります。"
  },
  rulesNoContestDefinitionTitle: {
    en: "11.5 No Contest",
    fr: "11.5 No Contest",
    es: "11.5 Sin resultado",
    ar: "11.5 بدون نتيجة",
    jp: "11.5 ノーコンテスト"
  },
  rulesNoContestBullet1: {
    en: "No Contest means a bout ruled a no contest by the referee or commission.",
    fr: "No Contest signifie un combat déclaré no contest par l'arbitre ou la commission.",
    es: "Sin resultado significa un combate declarado sin resultado por el árbitro o la comisión.",
    ar: "بدون نتيجة يعني نزال حُكم بأنه بدون نتيجة من قبل الحكم أو اللجنة.",
    jp: "ノーコンテストとは、レフェリーまたはコミッションによってノーコンテストと判定された試合を意味します。"
  },
  rulesNoContestBullet2: {
    en: "No Contests are treated as void for Fantasy scoring, and all users score 0 points.",
    fr: "Les No Contests sont traités comme annulés pour le score Fantasy, et tous les utilisateurs marquent 0 point.",
    es: "Los Sin resultado se tratan como anulados para la puntuación de Fantasy, y todos los usuarios obtienen 0 puntos.",
    ar: "تُعامل حالات بدون نتيجة على أنها ملغاة لتسجيل Fantasy، ويحصل جميع المستخدمين على 0 نقطة.",
    jp: "ノーコンテストはFantasyスコアリングにおいて無効として扱われ、すべてのユーザーは0ポイントになります。"
  },
  rulesCancelledPostponedDefinitionTitle: {
    en: "11.6 Cancelled or postponed bouts",
    fr: "11.6 Combats annulés ou reportés",
    es: "11.6 Combates cancelados o pospuestos",
    ar: "11.6 النزالات الملغاة أو المؤجلة",
    jp: "11.6 キャンセルまたは延期された試合"
  },
  rulesCancelledPostponedBullet: {
    en: "A bout that does not take place as scheduled (for example, cancellation or postponement) is treated as void, and all users score 0 points, unless the Platform clearly lists a replacement bout and allows new picks.",
    fr: "Un combat qui n'a pas lieu comme prévu (par exemple, annulation ou report) est traité comme annulé, et tous les utilisateurs marquent 0 point, sauf si la Plateforme liste clairement un combat de remplacement et autorise de nouveaux choix.",
    es: "Un combate que no tiene lugar según lo programado (por ejemplo, cancelación o aplazamiento) se trata como anulado, y todos los usuarios obtienen 0 puntos, a menos que la Plataforma liste claramente un combate de reemplazo y permita nuevas selecciones.",
    ar: "يُعامل النزال الذي لا يحدث كما هو مجدول (على سبيل المثال، الإلغاء أو التأجيل) على أنه ملغى، ويحصل جميع المستخدمين على 0 نقطة، ما لم تدرج المنصة بوضوح نزال بديل وتسمح باختيارات جديدة.",
    jp: "予定どおりに行われない試合（キャンセルまたは延期など）は無効として扱われ、プラットフォームが代替試合を明確にリストして新しい予想を許可しない限り、すべてのユーザーは0ポイントになります。"
  },
  rulesRoundSpecificOutcomesTitle: {
    en: "11.7 Round-specific outcomes",
    fr: "11.7 Résultats spécifiques au round",
    es: "11.7 Resultados específicos de round",
    ar: "11.7 النتائج الخاصة بالجولة",
    jp: "11.7 ラウンド固有の結果"
  },
  rulesRoundSpecificBullet1: {
    en: "A round-specific KO/TKO pick, the round refers to the official round number recorded at the time of stoppage.",
    fr: "Pour un choix de KO/TKO spécifique au round, le round fait référence au numéro de round officiel enregistré au moment de l'arrêt.",
    es: "En una selección de KO/TKO específico de round, el round se refiere al número de round oficial registrado en el momento de la detención.",
    ar: "اختيار KO/TKO محدد بالجولة، تشير الجولة إلى رقم الجولة الرسمي المسجل في وقت التوقف.",
    jp: "ラウンド固有のKO/TKO予想の場合、ラウンドはストップ時に記録された公式ラウンド番号を指します。"
  },
  rulesRoundSpecificBullet2: {
    en: "If the official round designation changes after the event, Fantasy scoring remains based on the round recorded when results are settled.",
    fr: "Si la désignation officielle du round change après l'événement, le score Fantasy reste basé sur le round enregistré lors du règlement des résultats.",
    es: "Si la designación oficial del round cambia después del evento, la puntuación de Fantasy permanece basada en el round registrado cuando se liquidan los resultados.",
    ar: "إذا تغير التعيين الرسمي للجولة بعد الحدث، يظل تسجيل Fantasy مبنيًا على الجولة المسجلة عند حسم النتائج.",
    jp: "イベント後に公式ラウンド指定が変更された場合でも、Fantasyスコアリングは結果が確定した時点で記録されたラウンドに基づいて保持されます。"
  },
  rulesRoundSpecificBullet3: {
    en: "Stoppages occurring between rounds are attributed to the round just completed, consistent with standard boxing records.",
    fr: "Les arrêts survenant entre les rounds sont attribués au round qui vient de se terminer, conformément aux enregistrements standards de boxe.",
    es: "Las detenciones que ocurren entre rounds se atribuyen al round recién completado, consistente con los registros estándar de boxeo.",
    ar: "يتم إسناد التوقفات التي تحدث بين الجولات إلى الجولة التي اكتملت للتو، بما يتسق مع سجلات الملاكمة القياسية.",
    jp: "ラウンド間で発生するストップは、標準的なボクシング記録と一致して、完了したばかりのラウンドに帰属されます。"
  },
  rulesChampionPickClarificationTitle: {
    en: "11.8 Champion Pick clarification",
    fr: "11.8 Clarification du Champion Pick",
    es: "11.8 Aclaración del Champion Pick",
    ar: "11.8 توضيح اختيار البطل",
    jp: "11.8 チャンピオンピックの明確化"
  },
  rulesChampionPickClarificationBullet1: {
    en: "The Champion Pick multiplier applies only if the picked fighter wins.",
    fr: "Le multiplicateur Champion Pick s'applique uniquement si le combattant choisi gagne.",
    es: "El multiplicador Champion Pick se aplica solo si el luchador seleccionado gana.",
    ar: "ينطبق مضاعف اختيار البطل فقط إذا فاز المقاتل المختار.",
    jp: "チャンピオンピック倍率は、選択したファイターが勝利した場合にのみ適用されます。"
  },
  rulesChampionPickClarificationBullet2: {
    en: "If the Champion Pick bout is void (draw, no contest, cancelled, or postponed), the bout scores 0 points, and no multiplier applies.",
    fr: "Si le combat Champion Pick est annulé (nul, no contest, annulé ou reporté), le combat rapporte 0 point, et aucun multiplicateur ne s'applique.",
    es: "Si el combate Champion Pick es anulado (empate, sin resultado, cancelado o pospuesto), el combate otorga 0 puntos y no se aplica ningún multiplicador.",
    ar: "إذا كان نزال اختيار البطل ملغى (تعادل، بدون نتيجة، ملغى، أو مؤجل)، يحصل النزال على 0 نقطة، ولا ينطبق أي مضاعف.",
    jp: "チャンピオンピックの試合が無効（引き分け、ノーコンテスト、キャンセル、または延期）の場合、その試合は0ポイントとなり、倍率は適用されません。"
  },
  rulesChipsInteractionDefinitionTitle: {
    en: "11.9 Chips interaction",
    fr: "11.9 Interaction des jetons",
    es: "11.9 Interacción de fichas",
    ar: "11.9 تفاعل الرقائق",
    jp: "11.9 チップの相互作用"
  },
  rulesChipsInteractionBullet1: {
    en: "Only one chip may be active per competition window.",
    fr: "Un seul jeton peut être actif par fenêtre de compétition.",
    es: "Solo una ficha puede estar activa por ventana de competición.",
    ar: "يمكن أن تكون رقاقة واحدة فقط نشطة لكل فترة منافسة.",
    jp: "競技期間ごとに有効にできるチップは1つのみです。"
  },
  rulesChipsInteractionBullet2: {
    en: "Chips apply only within the competition window in which they are activated.",
    fr: "Les jetons s'appliquent uniquement dans la fenêtre de compétition dans laquelle ils sont activés.",
    es: "Las fichas se aplican solo dentro de la ventana de competición en la que se activan.",
    ar: "تنطبق الرقائق فقط ضمن فترة المنافسة التي يتم تفعيلها فيها.",
    jp: "チップは、有効化された競技期間内でのみ適用されます。"
  },
  rulesChipsInteractionBullet3: {
    en: "Applied Chips do not carry over to future windows unless explicitly stated in-product.",
    fr: "Les jetons appliqués ne sont pas reportés aux fenêtres futures sauf mention explicite dans le produit.",
    es: "Las fichas aplicadas no se transfieren a ventanas futuras a menos que se indique explícitamente en el producto.",
    ar: "لا يتم نقل الرقائق المطبقة إلى الفترات المستقبلية ما لم يُذكر ذلك صراحة في المنتج.",
    jp: "適用されたチップは、製品内で明示的に記載されていない限り、将来の期間に持ち越されません。"
  },
  rulesOfficialTimingDataTitle: {
    en: "11.10 Official timing and data",
    fr: "11.10 Timing et données officiels",
    es: "11.10 Tiempo y datos oficiales",
    ar: "11.10 التوقيت والبيانات الرسمية",
    jp: "11.10 公式タイミングとデータ"
  },
  rulesOfficialTimingBullet1: {
    en: "Fantasy scoring relies on official bout results and timing as announced in-venue and recorded by recognized boxing authorities.",
    fr: "Le score Fantasy s'appuie sur les résultats et le timing officiels des combats tels qu'annoncés sur place et enregistrés par les autorités de boxe reconnues.",
    es: "La puntuación de Fantasy se basa en los resultados oficiales y el tiempo de los combates según lo anunciado en el lugar y registrado por las autoridades de boxeo reconocidas.",
    ar: "يعتمد تسجيل Fantasy على نتائج النزال الرسمية والتوقيت كما تم الإعلان عنها في المكان وتسجيلها من قبل سلطات الملاكمة المعترف بها.",
    jp: "Fantasyスコアリングは、会場内で発表され、認定されたボクシング当局によって記録された公式試合結果とタイミングに依存しています。"
  },
  rulesOfficialTimingBullet2: {
    en: "Minor discrepancies in unofficial broadcasts, commentary, or third-party feeds do not affect Fantasy scoring.",
    fr: "Les écarts mineurs dans les diffusions non officielles, les commentaires ou les flux tiers n'affectent pas le score Fantasy.",
    es: "Las discrepancias menores en transmisiones no oficiales, comentarios o feeds de terceros no afectan la puntuación de Fantasy.",
    ar: "الاختلافات الطفيفة في البث غير الرسمي أو التعليقات أو خلاصات الطرف الثالث لا تؤثر على تسجيل Fantasy.",
    jp: "非公式の放送、解説、またはサードパーティフィードでのわずかな不一致は、Fantasyスコアリングに影響しません。"
  },
  rulesEdgeCasesIntegrityTitle: {
    en: "11.11 Edge cases and integrity",
    fr: "11.11 Cas limites et intégrité",
    es: "11.11 Casos límite e integridad",
    ar: "11.11 الحالات الحدية والنزاهة",
    jp: "11.11 エッジケースと完全性"
  },
  rulesEdgeCasesBullet1: {
    en: "Boxing can involve unusual outcomes or administrative rulings. Where an edge case arises that is not explicitly covered in these Game Rules, Ring will apply a reasonable and consistent interpretation aligned with:",
    fr: "La boxe peut impliquer des résultats inhabituels ou des décisions administratives. Lorsqu'un cas limite survient qui n'est pas explicitement couvert par ces règles du jeu, Ring appliquera une interprétation raisonnable et cohérente alignée avec :",
    es: "El boxeo puede involucrar resultados inusuales o decisiones administrativas. Cuando surja un caso límite que no esté explícitamente cubierto en estas Reglas del juego, Ring aplicará una interpretación razonable y consistente alineada con:",
    ar: "يمكن أن تتضمن الملاكمة نتائج غير عادية أو قرارات إدارية. عندما تنشأ حالة حدية غير مشمولة صراحة في قواعد اللعبة هذه، ستطبق Ring تفسيرًا معقولاً ومتسقًا يتماشى مع:",
    jp: "ボクシングには通常とは異なる結果や管理上の判定が含まれる場合があります。これらのゲームルールで明示的にカバーされていないエッジケースが発生した場合、Ringは以下と整合する合理的で一貫性のある解釈を適用します："
  },
  rulesEdgeCasesSubBullet1: {
    en: "the official bout result,",
    fr: "le résultat officiel du combat,",
    es: "el resultado oficial del combate,",
    ar: "نتيجة النزال الرسمية،",
    jp: "公式試合結果、"
  },
  rulesEdgeCasesSubBullet2: {
    en: "the intent of the scoring system, and",
    fr: "l'intention du système de notation, et",
    es: "la intención del sistema de puntuación, y",
    ar: "نية نظام التسجيل، و",
    jp: "スコアリングシステムの意図、および"
  },
  rulesEdgeCasesSubBullet3: {
    en: "the integrity of the competition.",
    fr: "l'intégrité de la compétition.",
    es: "la integridad de la competición.",
    ar: "نزاهة المنافسة.",
    jp: "競技の完全性。"
  },
  rulesEdgeCasesBullet2: {
    en: "Ring's in-product scoring and leaderboard determination for such cases is final for Fantasy purposes.",
    fr: "La notation dans le produit et la détermination du classement de Ring pour de tels cas sont définitives aux fins de Fantasy.",
    es: "La puntuación en el producto y la determinación de la clasificación de Ring para tales casos son finales para los propósitos de Fantasy.",
    ar: "تسجيل Ring داخل المنتج وتحديد لوحة الصدارة لمثل هذه الحالات نهائي لأغراض Fantasy.",
    jp: "このような場合のRingの製品内スコアリングおよびリーダーボード決定は、Fantasyの目的において最終的なものです。"
  },

  // Game Rules - Section 8: Leaderboards (alternate - keeping for backward compatibility)
  rulesLeaderboardsTitle: {
    en: "8) Leaderboards",
    fr: "8) Classements",
    es: "8) Clasificaciones",
    ar: "8) لوحات الصدارة",
    jp: "8) リーダーボード"
  },
  rulesLeaderboardsIntro: {
    en: "Your points contribute to multiple leaderboards:",
    fr: "Vos points contribuent à plusieurs classements :",
    es: "Tus puntos contribuyen a múltiples clasificaciones:",
    ar: "تساهم نقاطك في لوحات صدارة متعددة:",
    jp: "あなたのポイントは複数のリーダーボードに反映されます："
  },
  rulesWeeklyLeaderboard: {
    en: "Weekly Leaderboard: Rankings for each competition window.",
    fr: "Classement hebdomadaire : Classements pour chaque fenêtre de compétition.",
    es: "Clasificación semanal: Clasificaciones para cada ventana de competición.",
    ar: "لوحة الصدارة الأسبوعية: التصنيفات لكل فترة منافسة.",
    jp: "週間リーダーボード：各競技期間のランキング。"
  },
  rulesQuarterlyLeaderboard: {
    en: "Quarterly Leaderboard: Cumulative rankings for each quarter.",
    fr: "Classement trimestriel : Classements cumulatifs pour chaque trimestre.",
    es: "Clasificación trimestral: Clasificaciones acumulativas para cada trimestre.",
    ar: "لوحة الصدارة الفصلية: التصنيفات التراكمية لكل ربع.",
    jp: "四半期リーダーボード：各四半期の累積ランキング。"
  },
  rulesAnnualLeaderboard: {
    en: "Annual Leaderboard: Cumulative rankings for the entire year.",
    fr: "Classement annuel : Classements cumulatifs pour toute l'année.",
    es: "Clasificación anual: Clasificaciones acumulativas para todo el año.",
    ar: "لوحة الصدارة السنوية: التصنيفات التراكمية للعام بأكمله.",
    jp: "年間リーダーボード：1年間全体の累積ランキング。"
  },

  // Game Rules - Section 9: Tie-breakers
  rulesTiebreakersTitle: {
    en: "9) Tie-breakers",
    fr: "9) Départages",
    es: "9) Desempates",
    ar: "9) قواعد الفصل بين المتعادلين",
    jp: "9) タイブレーカー"
  },
  simpleRulesTiebreakersIntro: {
    en: "In the event of a tie on any leaderboard, the following tie-breakers apply in order:",
    fr: "En cas d'égalité sur n'importe quel classement, les départages suivants s'appliquent dans l'ordre :",
    es: "En caso de empate en cualquier clasificación, los siguientes desempates se aplican en orden:",
    ar: "في حالة التعادل على أي لوحة صدارة، تُطبق قواعد الفصل التالية بالترتيب:",
    jp: "いずれかのリーダーボードで同点の場合、以下のタイブレーカーが順に適用されます："
  },
  rulesTiebreaker1: {
    en: "Total number of correct picks",
    fr: "Nombre total de choix corrects",
    es: "Número total de selecciones correctas",
    ar: "إجمالي عدد الاختيارات الصحيحة",
    jp: "正解予想の総数"
  },
  rulesTiebreaker2: {
    en: "Total number of correct Champion Picks",
    fr: "Nombre total de Champion Picks corrects",
    es: "Número total de Champion Picks correctos",
    ar: "إجمالي عدد اختيارات البطل الصحيحة",
    jp: "正解チャンピオンピックの総数"
  },
  rulesTiebreaker3: {
    en: "Earlier submission time of picks",
    fr: "Heure de soumission des choix antérieure",
    es: "Tiempo de envío de selecciones más temprano",
    ar: "وقت تقديم الاختيارات الأسبق",
    jp: "予想の提出時刻が早い方"
  },
  rulesTiebreaker4: {
    en: "Random selection (if all other tie-breakers fail)",
    fr: "Sélection aléatoire (si tous les autres départages échouent)",
    es: "Selección aleatoria (si todos los demás desempates fallan)",
    ar: "اختيار عشوائي (إذا فشلت جميع قواعد الفصل الأخرى)",
    jp: "ランダム選択（他のすべてのタイブレーカーで決まらない場合）"
  },

  // Game Rules - Section 10: Cancellations and changes
  rulesCancellationsTitle: {
    en: "10) Cancellations and changes",
    fr: "10) Annulations et modifications",
    es: "10) Cancelaciones y cambios",
    ar: "10) الإلغاءات والتغييرات",
    jp: "10) キャンセルと変更"
  },
  rulesCancellationsIntro: {
    en: "If a bout is cancelled, postponed, or significantly changed after locks:",
    fr: "Si un combat est annulé, reporté ou modifié de manière significative après le verrouillage :",
    es: "Si un combate es cancelado, pospuesto o cambiado significativamente después del bloqueo:",
    ar: "إذا تم إلغاء نزال أو تأجيله أو تغييره بشكل كبير بعد القفل:",
    jp: "ロック後に試合がキャンセル、延期、または大幅に変更された場合："
  },
  rulesCancellationsBullet1: {
    en: "The bout will be voided and no points will be awarded or deducted.",
    fr: "Le combat sera annulé et aucun point ne sera attribué ou déduit.",
    es: "El combate será anulado y no se otorgarán ni deducirán puntos.",
    ar: "سيتم إلغاء النزال ولن يتم منح أو خصم أي نقاط.",
    jp: "試合は無効となり、ポイントの付与も減点も行われません。"
  },
  rulesCancellationsBullet2: {
    en: "Any Champion Pick or chips used on that bout may be refunded at Ring's discretion.",
    fr: "Tout Champion Pick ou jeton utilisé sur ce combat peut être remboursé à la discrétion de Ring.",
    es: "Cualquier Champion Pick o fichas usadas en ese combate pueden ser reembolsadas a discreción de Ring.",
    ar: "قد يتم استرداد أي اختيار بطل أو رقائق مستخدمة في ذلك النزال وفقًا لتقدير Ring.",
    jp: "その試合に使用されたチャンピオンピックやチップは、Ringの裁量で返還される場合があります。"
  },
  rulesCancellationsBullet3: {
    en: "Ring will communicate any changes through the Platform.",
    fr: "Ring communiquera tout changement via la Plateforme.",
    es: "Ring comunicará cualquier cambio a través de la Plataforma.",
    ar: "ستقوم Ring بإبلاغ أي تغييرات من خلال المنصة.",
    jp: "Ringはプラットフォームを通じて変更を通知します。"
  },

  // Game Rules - Scoring Tables
  rulesScoringTableTitle: {
    en: "Points Scoring Summary",
    fr: "Résumé de la notation des points",
    es: "Resumen de puntuación de puntos",
    ar: "ملخص تسجيل النقاط",
    jp: "ポイントスコアリング概要"
  },
  rulesScoringTableHeaderOutcome: {
    en: "Outcome",
    fr: "Résultat",
    es: "Resultado",
    ar: "النتيجة",
    jp: "結果"
  },
  rulesScoringTableHeaderDescription: {
    en: "Description",
    fr: "Description",
    es: "Descripción",
    ar: "الوصف",
    jp: "説明"
  },
  rulesScoringTableHeaderPointsImpact: {
    en: "Points Impact",
    fr: "Impact sur les points",
    es: "Impacto en puntos",
    ar: "تأثير النقاط",
    jp: "ポイントへの影響"
  },
  rulesScoringTableRow1Outcome: {
    en: "Picked fighter wins",
    fr: "Le combattant choisi gagne",
    es: "El luchador seleccionado gana",
    ar: "المقاتل المختار يفوز",
    jp: "選択したファイターが勝利"
  },
  rulesScoringTableRow1Desc: {
    en: "Correct selection of bout winner",
    fr: "Sélection correcte du vainqueur du combat",
    es: "Selección correcta del ganador del combate",
    ar: "اختيار صحيح للفائز في النزال",
    jp: "試合の勝者を正確に選択"
  },
  rulesScoringTableRow2Outcome: {
    en: "Decision win bonus",
    fr: "Bonus de victoire par décision",
    es: "Bonificación de victoria por decisión",
    ar: "مكافأة الفوز بالقرار",
    jp: "判定勝利ボーナス"
  },
  rulesScoringTableRow2Desc: {
    en: "Picked fighter wins by decision",
    fr: "Le combattant choisi gagne par décision",
    es: "El luchador seleccionado gana por decisión",
    ar: "المقاتل المختار يفوز بالقرار",
    jp: "選択したファイターが判定で勝利"
  },
  rulesScoringTableRow3Outcome: {
    en: "KO/TKO win bonus",
    fr: "Bonus de victoire par KO/TKO",
    es: "Bonificación de victoria por KO/TKO",
    ar: "مكافأة الفوز بـ KO/TKO",
    jp: "KO/TKO勝利ボーナス"
  },
  rulesScoringTableRow3Desc: {
    en: "Picked fighter wins by KO/TKO",
    fr: "Le combattant choisi gagne par KO/TKO",
    es: "El luchador seleccionado gana por KO/TKO",
    ar: "المقاتل المختار يفوز بـ KO/TKO",
    jp: "選択したファイターがKO/TKOで勝利"
  },
  rulesScoringTableRow4Outcome: {
    en: "KO/TKO in specific round bonus",
    fr: "Bonus KO/TKO dans un round spécifique",
    es: "Bonificación de KO/TKO en round específico",
    ar: "مكافأة KO/TKO في جولة محددة",
    jp: "特定ラウンドでのKO/TKOボーナス"
  },
  rulesScoringTableRow4Desc: {
    en: "Only when the Platform offers a round-specific KO/TKO pick",
    fr: "Uniquement lorsque la Plateforme propose un choix de KO/TKO spécifique au round",
    es: "Solo cuando la Plataforma ofrece una selección de KO/TKO específico de round",
    ar: "فقط عندما توفر المنصة اختيار KO/TKO محدد بالجولة",
    jp: "プラットフォームがラウンド固有のKO/TKO予想を提供する場合のみ"
  },
  rulesScoringTableRow5Outcome: {
    en: "Champion Pick wins",
    fr: "Champion Pick gagne",
    es: "Champion Pick gana",
    ar: "اختيار البطل يفوز",
    jp: "チャンピオンピックが勝利"
  },
  rulesScoringTableRow5Desc: {
    en: "Your selected Champion Pick wins; multiplies that bout's total points",
    fr: "Votre Champion Pick sélectionné gagne ; multiplie le total des points de ce combat",
    es: "Tu Champion Pick seleccionado gana; multiplica los puntos totales de ese combate",
    ar: "اختيار البطل الذي اخترته يفوز؛ يضاعف إجمالي نقاط ذلك النزال",
    jp: "選択したチャンピオンピックが勝利；その試合の合計ポイントを倍増"
  },
  rulesScoringTableRow5Points: {
    en: "2x (total bout points)",
    fr: "2x (points totaux du combat)",
    es: "2x (puntos totales del combate)",
    ar: "2x (إجمالي نقاط النزال)",
    jp: "2倍（試合の合計ポイント）"
  },
  rulesScoringTableRow6Outcome: {
    en: "No pick",
    fr: "Pas de choix",
    es: "Sin selección",
    ar: "لا يوجد اختيار",
    jp: "予想なし"
  },
  rulesScoringTableRow6Desc: {
    en: "You did not submit a pick for that bout",
    fr: "Vous n'avez pas soumis de choix pour ce combat",
    es: "No enviaste una selección para ese combate",
    ar: "لم تقدم اختيارًا لذلك النزال",
    jp: "その試合の予想を提出していない"
  },
  rulesScoringTableRow7Outcome: {
    en: "Picked fighter loses by decision",
    fr: "Le combattant choisi perd par décision",
    es: "El luchador seleccionado pierde por decisión",
    ar: "المقاتل المختار يخسر بالقرار",
    jp: "選択したファイターが判定で敗北"
  },
  rulesScoringTableRow7Desc: {
    en: "Your pick loses by decision",
    fr: "Votre choix perd par décision",
    es: "Tu selección pierde por decisión",
    ar: "اختيارك يخسر بالقرار",
    jp: "あなたの予想が判定で敗北"
  },
  rulesScoringTableRow8Outcome: {
    en: "Picked fighter loses by KO/TKO",
    fr: "Le combattant choisi perd par KO/TKO",
    es: "El luchador seleccionado pierde por KO/TKO",
    ar: "المقاتل المختار يخسر بـ KO/TKO",
    jp: "選択したファイターがKO/TKOで敗北"
  },
  rulesScoringTableRow8Desc: {
    en: "Your pick loses by KO/TKO",
    fr: "Votre choix perd par KO/TKO",
    es: "Tu selección pierde por KO/TKO",
    ar: "اختيارك يخسر بـ KO/TKO",
    jp: "あなたの予想がKO/TKOで敗北"
  },
  rulesScoringTableRow9Outcome: {
    en: "Picked fighter loses by disqualification (DQ)",
    fr: "Le combattant choisi perd par disqualification (DQ)",
    es: "El luchador seleccionado pierde por descalificación (DQ)",
    ar: "المقاتل المختار يخسر بالاستبعاد (DQ)",
    jp: "選択したファイターが失格（DQ）で敗北"
  },
  rulesScoringTableRow9Desc: {
    en: "Your pick loses by DQ",
    fr: "Votre choix perd par DQ",
    es: "Tu selección pierde por DQ",
    ar: "اختيارك يخسر بـ DQ",
    jp: "あなたの予想がDQで敗北"
  },
  rulesScoringTableRow10Outcome: {
    en: "Draw",
    fr: "Match nul",
    es: "Empate",
    ar: "التعادل",
    jp: "引き分け"
  },
  rulesScoringTableRow10Desc: {
    en: "Any draw (split/majority/unanimous)",
    fr: "Tout match nul (partagé/majoritaire/unanime)",
    es: "Cualquier empate (dividido/mayoritario/unánime)",
    ar: "أي تعادل (منقسم/بالأغلبية/إجماعي)",
    jp: "すべての引き分け（スプリット/マジョリティ/全員一致）"
  },
  rulesScoringTableRow10Points: {
    en: "0 (treated as void)",
    fr: "0 (traité comme annulé)",
    es: "0 (tratado como anulado)",
    ar: "0 (يُعامل كملغى)",
    jp: "0（無効として扱われる）"
  },
  rulesScoringTableRow11Outcome: {
    en: "No Contest",
    fr: "No Contest",
    es: "Sin resultado",
    ar: "بدون نتيجة",
    jp: "ノーコンテスト"
  },
  rulesScoringTableRow11Desc: {
    en: "No Contest",
    fr: "No Contest",
    es: "Sin resultado",
    ar: "بدون نتيجة",
    jp: "ノーコンテスト"
  },
  rulesScoringTableRow12Outcome: {
    en: "Cancelled/postponed bout",
    fr: "Combat annulé/reporté",
    es: "Combate cancelado/pospuesto",
    ar: "نزال ملغى/مؤجل",
    jp: "キャンセル/延期された試合"
  },
  rulesScoringTableRow12Desc: {
    en: "Bout does not take place as scheduled",
    fr: "Le combat n'a pas lieu comme prévu",
    es: "El combate no tiene lugar según lo programado",
    ar: "لم يحدث النزال كما هو مجدول",
    jp: "試合が予定どおりに行われない"
  },

  // Chips Table Translations
  rulesChipsTableTitle: {
    en: "Chips (Boosts) Summary",
    fr: "Résumé des jetons (Boosts)",
    es: "Resumen de fichas (Potenciadores)",
    ar: "ملخص الرقائق (المعززات)",
    jp: "チップ（ブースト）概要"
  },
  rulesChipsTableHeaderChip: {
    en: "Chip",
    fr: "Jeton",
    es: "Ficha",
    ar: "الرقاقة",
    jp: "チップ"
  },
  rulesChipsTableHeaderWhatItDoes: {
    en: "What It Does",
    fr: "Ce qu'il fait",
    es: "Qué hace",
    ar: "ماذا يفعل",
    jp: "機能"
  },
  rulesChipsTableHeaderPointsImpact: {
    en: "Points Impact",
    fr: "Impact sur les points",
    es: "Impacto en puntos",
    ar: "تأثير النقاط",
    jp: "ポイントへの影響"
  },
  rulesChipsTableHeaderBestTime: {
    en: "Best Time to Play",
    fr: "Meilleur moment pour jouer",
    es: "Mejor momento para jugar",
    ar: "أفضل وقت للعب",
    jp: "使用に最適なタイミング"
  },
  rulesChipsTableKoFrenzyName: {
    en: "🥊 KO Frenzy",
    fr: "🥊 KO Frenzy",
    es: "🥊 KO Frenzy",
    ar: "🥊 جنون الضربة القاضية",
    jp: "🥊 KO フレンジー"
  },
  rulesChipsTableKoFrenzyDoes: {
    en: "All KO/TKO wins in the window score double points – whether you picked them or not",
    fr: "Tous les KO/TKO dans la fenêtre rapportent le double de points – que vous les ayez choisis ou non",
    es: "Todas las victorias de KO/TKO en la ventana obtienen el doble de puntos, las hayas elegido o no",
    ar: "جميع انتصارات KO/TKO في الفترة تحصل على نقاط مضاعفة - سواء اخترتها أم لا",
    jp: "期間内のすべてのKO/TKO勝利はポイントが2倍になります - 選択したかどうかに関係なく"
  },
  rulesChipsTableKoFrenzyImpact: {
    en: "2x points for all KO/TKO outcomes",
    fr: "2x points pour tous les résultats KO/TKO",
    es: "2x puntos para todos los resultados de KO/TKO",
    ar: "ضعف النقاط لجميع نتائج KO/TKO",
    jp: "すべてのKO/TKO結果で2倍ポイント"
  },
  rulesChipsTableKoFrenzyBestTime: {
    en: "Cards stacked with heavy punchers / multiple stoppage risk",
    fr: "Cartes avec de gros frappeurs / risque d'arrêts multiples",
    es: "Carteleras cargadas de pegadores / riesgo de múltiples detenciones",
    ar: "البطاقات المليئة بالضاربين الأقوياء / خطر توقفات متعددة",
    jp: "強打者が揃ったカード / 複数のストップリスク"
  },
  rulesChipsTableRingChampionBeltName: {
    en: "🏆 Ring Champion Belt",
    fr: "🏆 Ceinture Ring Champion",
    es: "🏆 Cinturón Ring Champion",
    ar: "🏆 حزام Ring Champion",
    jp: "🏆 Ring Champion ベルト"
  },
  rulesChipsTableRingChampionBeltDoes: {
    en: "Supercharges your Champion Pick",
    fr: "Surcharge votre Champion Pick",
    es: "Supercarga tu Champion Pick",
    ar: "يعزز اختيار البطل الخاص بك",
    jp: "チャンピオンピックを強化"
  },
  rulesChipsTableRingChampionBeltImpact: {
    en: "Champion Pick becomes 4x (instead of 2x)",
    fr: "Champion Pick devient 4x (au lieu de 2x)",
    es: "Champion Pick se convierte en 4x (en lugar de 2x)",
    ar: "يصبح اختيار البطل 4 أضعاف (بدلاً من ضعفين)",
    jp: "チャンピオンピックが4倍（2倍ではなく）"
  },
  rulesChipsTableRingChampionBeltBestTime: {
    en: "Big headliners you're confident in",
    fr: "Grands combats principaux dans lesquels vous êtes confiant",
    es: "Grandes eventos estelares en los que confías",
    ar: "الأحداث الرئيسية الكبيرة التي تثق بها",
    jp: "自信のある大きなメインイベント"
  },
  rulesChipsTableGoDistanceName: {
    en: "🎯 Go the Distance",
    fr: "🎯 Aller la distance",
    es: "🎯 Ir la distancia",
    ar: "🎯 الذهاب للمسافة",
    jp: "🎯 ゴー・ザ・ディスタンス"
  },
  rulesChipsTableGoDistanceDoes: {
    en: "Any fight that ends by decision scores double points for that bout",
    fr: "Tout combat qui se termine par décision rapporte le double de points pour ce combat",
    es: "Cualquier pelea que termine por decisión obtiene el doble de puntos para ese combate",
    ar: "أي نزال ينتهي بقرار يحصل على نقاط مضاعفة لذلك النزال",
    jp: "判定で終了する試合はその試合で2倍のポイント"
  },
  rulesChipsTableGoDistanceImpactTitle: {
    en: "2x points for decision outcomes",
    fr: "2x points pour les résultats par décision",
    es: "2x puntos para resultados por decisión",
    ar: "ضعف النقاط لنتائج القرار",
    jp: "判定結果で2倍ポイント"
  },
  rulesChipsTableGoDistanceImpactExample: {
    en: "Example: if you picked the winning fighter but selected a KO/TKO method and the bout goes to decision, you still receive 2x your base win points (i.e., 2x +10).",
    fr: "Exemple : si vous avez choisi le combattant gagnant mais sélectionné une méthode KO/TKO et que le combat va à la décision, vous recevez toujours 2x vos points de victoire de base (c'est-à-dire 2x +10).",
    es: "Ejemplo: si elegiste al luchador ganador pero seleccionaste un método KO/TKO y el combate va a decisión, aún recibes 2x tus puntos de victoria base (es decir, 2x +10).",
    ar: "مثال: إذا اخترت المقاتل الفائز لكن اخترت طريقة KO/TKO وذهب النزال إلى القرار، فستظل تحصل على ضعف نقاط الفوز الأساسية (أي 2x +10).",
    jp: "例：勝利ファイターを選択したが、KO/TKO方法を選択し、試合が判定になった場合でも、基本勝利ポイントの2倍（つまり2x +10）を受け取ります。"
  },
  rulesChipsTableGoDistanceBestTime: {
    en: "Fights likely to go to the judges / low stoppage risk",
    fr: "Combats susceptibles d'aller aux juges / faible risque d'arrêt",
    es: "Peleas que probablemente irán a los jueces / bajo riesgo de detención",
    ar: "النزالات التي من المحتمل أن تذهب إلى الحكام / خطر توقف منخفض",
    jp: "ジャッジに委ねられる可能性が高い試合 / ストップリスクが低い"
  },

  // Game Rules - Disclaimer
  rulesDisclaimer: {
    en: "These Game Rules are subject to change. Ring reserves the right to modify these rules at any time. Please check this page regularly for updates. Last updated: January 2026.",
    fr: "Ces règles du jeu sont susceptibles d'être modifiées. Ring se réserve le droit de modifier ces règles à tout moment. Veuillez consulter cette page régulièrement pour les mises à jour. Dernière mise à jour : janvier 2026.",
    es: "Estas reglas del juego están sujetas a cambios. Ring se reserva el derecho de modificar estas reglas en cualquier momento. Por favor, consulta esta página regularmente para actualizaciones. Última actualización: enero 2026.",
    ar: "قواعد اللعبة هذه قابلة للتغيير. تحتفظ Ring بالحق في تعديل هذه القواعد في أي وقت. يرجى التحقق من هذه الصفحة بانتظام للحصول على التحديثات. آخر تحديث: يناير 2026.",
    jp: "これらのゲームルールは変更される場合があります。Ringはいつでもこれらのルールを変更する権利を留保します。更新については定期的にこのページをご確認ください。最終更新：2026年1月。"
  },

  // FAQs Section (hidden for now but translations ready)
  faqsTitle: {
    en: "FAQs",
    fr: "FAQ",
    es: "Preguntas frecuentes",
    ar: "الأسئلة الشائعة",
    jp: "よくある質問"
  },
  faqGettingStarted: {
    en: "Getting Started",
    fr: "Pour commencer",
    es: "Primeros pasos",
    ar: "البدء",
    jp: "はじめに"
  },
  faqMakingPicks: {
    en: "Making picks",
    fr: "Faire des choix",
    es: "Hacer selecciones",
    ar: "إجراء الاختيارات",
    jp: "予想を行う"
  },
  faqScoringPoints: {
    en: "Scoring & points",
    fr: "Notation et points",
    es: "Puntuación y puntos",
    ar: "التسجيل والنقاط",
    jp: "スコアとポイント"
  },
  faqLeaguesPrizes: {
    en: "Leagues & prizes",
    fr: "Ligues et prix",
    es: "Ligas y premios",
    ar: "الدوريات والجوائز",
    jp: "リーグと賞品"
  },
  faqFairPlay: {
    en: "Fair play",
    fr: "Fair-play",
    es: "Juego limpio",
    ar: "اللعب النظيف",
    jp: "フェアプレー"
  },
  faqHowJoin: {
    en: "How do I join the fantasy game?",
    fr: "Comment rejoindre le jeu fantasy ?",
    es: "¿Cómo me uno al juego de fantasía?",
    ar: "كيف أنضم إلى لعبة الفانتازيا؟",
    jp: "ファンタジーゲームに参加するには？"
  },
  faqHowJoinAnswer: {
    en: "To join the fantasy game, simply sign up for an account and start making your picks. You can participate in both public and private leagues, compete for prizes, and climb the global rankings.",
    fr: "Pour rejoindre le jeu fantasy, inscrivez-vous simplement et commencez à faire vos choix. Vous pouvez participer aux ligues publiques et privées, concourir pour des prix et monter dans le classement mondial.",
    es: "Para unirte al juego de fantasía, simplemente regístrate y comienza a hacer tus selecciones. Puedes participar en ligas públicas y privadas, competir por premios y subir en las clasificaciones globales.",
    ar: "للانضمام إلى لعبة الفانتازيا، ما عليك سوى التسجيل والبدء في إجراء اختياراتك. يمكنك المشاركة في الدوريات العامة والخاصة، والتنافس على الجوائز، والصعود في التصنيفات العالمية.",
    jp: "ファンタジーゲームに参加するには、アカウントを登録して予想を始めるだけです。パブリックリーグとプライベートリーグの両方に参加し、賞品を競い、グローバルランキングを上げることができます。"
  },
  faqPayToPlay: {
    en: "Do I need to pay to play?",
    fr: "Dois-je payer pour jouer ?",
    es: "¿Necesito pagar para jugar?",
    ar: "هل أحتاج إلى الدفع للعب؟",
    jp: "プレイするのにお金がかかりますか？"
  },
  faqPayToPlayAnswer: {
    en: "No, the fantasy game is completely free to play. You can join public leagues and create private leagues with your friends at no cost. All prizes are awarded based on your performance.",
    fr: "Non, le jeu fantasy est entièrement gratuit. Vous pouvez rejoindre des ligues publiques et créer des ligues privées avec vos amis sans frais. Tous les prix sont attribués en fonction de vos performances.",
    es: "No, el juego de fantasía es completamente gratis. Puedes unirte a ligas públicas y crear ligas privadas con tus amigos sin costo. Todos los premios se otorgan según tu rendimiento.",
    ar: "لا، لعبة الفانتازيا مجانية تمامًا. يمكنك الانضمام إلى الدوريات العامة وإنشاء دوريات خاصة مع أصدقائك دون أي تكلفة. تُمنح جميع الجوائز بناءً على أدائك.",
    jp: "いいえ、ファンタジーゲームは完全に無料でプレイできます。パブリックリーグに参加したり、友達とプライベートリーグを無料で作成できます。すべての賞品はパフォーマンスに基づいて授与されます。"
  },
  faqWhatToPick: {
    en: "What do I have to pick for each fight?",
    fr: "Que dois-je choisir pour chaque combat ?",
    es: "¿Qué tengo que elegir para cada pelea?",
    ar: "ماذا يجب أن أختار لكل نزال؟",
    jp: "各試合で何を予想する必要がありますか？"
  },
  faqWhatToPickAnswer: {
    en: "For each fight, you need to pick the winner and optionally predict the round of knockout for bonus points. You can also use chips to multiply your points for specific fights.",
    fr: "Pour chaque combat, vous devez choisir le vainqueur et éventuellement prédire le round du KO pour des points bonus. Vous pouvez également utiliser des jetons pour multiplier vos points pour des combats spécifiques.",
    es: "Para cada pelea, necesitas elegir al ganador y opcionalmente predecir el round del nocaut para puntos de bonificación. También puedes usar fichas para multiplicar tus puntos en peleas específicas.",
    ar: "لكل نزال، تحتاج إلى اختيار الفائز واختياريًا توقع جولة الضربة القاضية للحصول على نقاط إضافية. يمكنك أيضًا استخدام الرقائق لمضاعفة نقاطك لنزالات محددة.",
    jp: "各試合では、勝者を予想し、オプションでボーナスポイントのためにノックアウトラウンドを予想できます。特定の試合でチップを使用してポイントを倍増させることもできます。"
  },
  faqChangePicks: {
    en: "Can I change my picks after submitting them?",
    fr: "Puis-je modifier mes choix après les avoir soumis ?",
    es: "¿Puedo cambiar mis selecciones después de enviarlas?",
    ar: "هل يمكنني تغيير اختياراتي بعد تقديمها؟",
    jp: "送信後に予想を変更できますか？"
  },
  faqChangePicksAnswer: {
    en: "Yes, you can change your picks up until the fight card starts. Once the event begins, all picks are locked and cannot be modified. Make sure to review your selections before the deadline.",
    fr: "Oui, vous pouvez modifier vos choix jusqu'au début de la carte de combat. Une fois l'événement commencé, tous les choix sont verrouillés et ne peuvent pas être modifiés. Assurez-vous de revoir vos sélections avant la date limite.",
    es: "Sí, puedes cambiar tus selecciones hasta que comience la cartelera. Una vez que el evento comienza, todas las selecciones se bloquean y no se pueden modificar. Asegúrate de revisar tus selecciones antes de la fecha límite.",
    ar: "نعم، يمكنك تغيير اختياراتك حتى تبدأ بطاقة القتال. بمجرد بدء الحدث، يتم قفل جميع الاختيارات ولا يمكن تعديلها. تأكد من مراجعة اختياراتك قبل الموعد النهائي.",
    jp: "はい、ファイトカードが始まるまで予想を変更できます。イベントが始まると、すべての予想がロックされ、変更できなくなります。締め切り前に選択内容を確認してください。"
  },
  faqHowScoring: {
    en: "How does scoring work?",
    fr: "Comment fonctionne la notation ?",
    es: "¿Cómo funciona la puntuación?",
    ar: "كيف يعمل نظام التسجيل؟",
    jp: "スコアリングはどのように機能しますか？"
  },
  faqHowScoringAnswer: {
    en: "Scoring is based on correctly picking fight winners. You earn base points for each correct pick, with bonus points for predicting the exact round of knockout. Points accumulate throughout the season across multiple fight cards.",
    fr: "La notation est basée sur le choix correct des vainqueurs des combats. Vous gagnez des points de base pour chaque choix correct, avec des points bonus pour avoir prédit le round exact du KO. Les points s'accumulent tout au long de la saison sur plusieurs cartes de combat.",
    es: "La puntuación se basa en elegir correctamente a los ganadores de las peleas. Ganas puntos base por cada selección correcta, con puntos de bonificación por predecir el round exacto del nocaut. Los puntos se acumulan a lo largo de la temporada en múltiples carteleras.",
    ar: "يعتمد التسجيل على اختيار الفائزين في النزالات بشكل صحيح. تكسب نقاطًا أساسية لكل اختيار صحيح، مع نقاط إضافية لتوقع الجولة الدقيقة للضربة القاضية. تتراكم النقاط طوال الموسم عبر بطاقات قتال متعددة.",
    jp: "スコアリングは試合の勝者を正しく予想することに基づいています。正確な予想ごとに基本ポイントを獲得し、ノックアウトの正確なラウンドを予想するとボーナスポイントを獲得します。ポイントはシーズンを通じて複数のファイトカードで蓄積されます。"
  },
  faqChips: {
    en: "What do the chips mean and how do I use them?",
    fr: "Que signifient les jetons et comment les utiliser ?",
    es: "¿Qué significan las fichas y cómo las uso?",
    ar: "ماذا تعني الرقائق وكيف أستخدمها؟",
    jp: "チップとは何ですか？どのように使いますか？"
  },
  faqChipsAnswer: {
    en: "Chips are multipliers that you can apply to specific fights to increase your potential points. Use them strategically on fights where you're confident in your pick. Each chip multiplies your points for that fight, so choose wisely.",
    fr: "Les jetons sont des multiplicateurs que vous pouvez appliquer à des combats spécifiques pour augmenter vos points potentiels. Utilisez-les stratégiquement sur les combats où vous êtes confiant dans votre choix. Chaque jeton multiplie vos points pour ce combat, alors choisissez judicieusement.",
    es: "Las fichas son multiplicadores que puedes aplicar a peleas específicas para aumentar tus puntos potenciales. Úsalas estratégicamente en peleas donde confías en tu selección. Cada ficha multiplica tus puntos para esa pelea, así que elige sabiamente.",
    ar: "الرقائق هي مضاعفات يمكنك تطبيقها على نزالات محددة لزيادة نقاطك المحتملة. استخدمها بشكل استراتيجي في النزالات التي تثق في اختيارك فيها. كل رقاقة تضاعف نقاطك لذلك النزال، لذا اختر بحكمة.",
    jp: "チップは特定の試合に適用して潜在的なポイントを増やすことができる倍率です。自信のある予想の試合で戦略的に使用してください。各チップはその試合のポイントを倍増させるので、賢く選んでください。"
  },
  faqPlayWithFriends: {
    en: "Can I play with friends?",
    fr: "Puis-je jouer avec des amis ?",
    es: "¿Puedo jugar con amigos?",
    ar: "هل يمكنني اللعب مع الأصدقاء؟",
    jp: "友達と一緒にプレイできますか？"
  },
  faqPlayWithFriendsAnswer: {
    en: "Absolutely! You can create private leagues and invite your friends to compete. Private leagues allow you to compete head-to-head with people you know, making the game more fun and competitive.",
    fr: "Absolument ! Vous pouvez créer des ligues privées et inviter vos amis à concourir. Les ligues privées vous permettent de vous affronter avec des personnes que vous connaissez, rendant le jeu plus amusant et compétitif.",
    es: "¡Por supuesto! Puedes crear ligas privadas e invitar a tus amigos a competir. Las ligas privadas te permiten competir cara a cara con personas que conoces, haciendo el juego más divertido y competitivo.",
    ar: "بالتأكيد! يمكنك إنشاء دوريات خاصة ودعوة أصدقائك للمنافسة. تتيح لك الدوريات الخاصة التنافس وجهاً لوجه مع أشخاص تعرفهم، مما يجعل اللعبة أكثر متعة وتنافسية.",
    jp: "もちろんです！プライベートリーグを作成して友達を招待して競争できます。プライベートリーグでは知り合いと直接対決でき、ゲームがより楽しく競争的になります。"
  },
  faqPrizes: {
    en: "Are there prizes?",
    fr: "Y a-t-il des prix ?",
    es: "¿Hay premios?",
    ar: "هل توجد جوائز؟",
    jp: "賞品はありますか？"
  },
  faqPrizesAnswer: {
    en: "Yes! There are prizes available throughout the season. Prizes are awarded based on your performance in both public and private leagues. Check the rankings page to see current prize opportunities and leaderboards.",
    fr: "Oui ! Des prix sont disponibles tout au long de la saison. Les prix sont attribués en fonction de vos performances dans les ligues publiques et privées. Consultez la page des classements pour voir les opportunités de prix actuelles et les classements.",
    es: "¡Sí! Hay premios disponibles a lo largo de la temporada. Los premios se otorgan según tu rendimiento en ligas públicas y privadas. Consulta la página de clasificaciones para ver las oportunidades de premios actuales y las clasificaciones.",
    ar: "نعم! هناك جوائز متاحة طوال الموسم. تُمنح الجوائز بناءً على أدائك في الدوريات العامة والخاصة. تحقق من صفحة التصنيفات لمعرفة فرص الجوائز الحالية ولوحات الصدارة.",
    jp: "はい！シーズンを通じて賞品が用意されています。賞品はパブリックリーグとプライベートリーグの両方でのパフォーマンスに基づいて授与されます。ランキングページで現在の賞品機会とリーダーボードを確認してください。"
  },
  faqMultipleAccounts: {
    en: "Can I have more than one account?",
    fr: "Puis-je avoir plus d'un compte ?",
    es: "¿Puedo tener más de una cuenta?",
    ar: "هل يمكنني امتلاك أكثر من حساب واحد؟",
    jp: "複数のアカウントを持てますか？"
  },
  faqMultipleAccountsAnswer: {
    en: "No, each player is allowed only one account. Creating multiple accounts violates our fair play policy and may result in disqualification from prizes and permanent ban from the platform.",
    fr: "Non, chaque joueur n'est autorisé qu'à un seul compte. La création de plusieurs comptes viole notre politique de fair-play et peut entraîner une disqualification des prix et une interdiction permanente de la plateforme.",
    es: "No, cada jugador solo puede tener una cuenta. Crear múltiples cuentas viola nuestra política de juego limpio y puede resultar en descalificación de premios y prohibición permanente de la plataforma.",
    ar: "لا، يُسمح لكل لاعب بحساب واحد فقط. إنشاء حسابات متعددة ينتهك سياسة اللعب النظيف لدينا وقد يؤدي إلى الاستبعاد من الجوائز والحظر الدائم من المنصة.",
    jp: "いいえ、各プレイヤーは1つのアカウントのみ許可されています。複数のアカウントを作成することはフェアプレーポリシーに違反し、賞品からの失格やプラットフォームからの永久追放につながる可能性があります。"
  },
  faqCheating: {
    en: "What happens if someone cheats?",
    fr: "Que se passe-t-il si quelqu'un triche ?",
    es: "¿Qué pasa si alguien hace trampa?",
    ar: "ماذا يحدث إذا غش شخص ما؟",
    jp: "誰かが不正をしたらどうなりますか？"
  },
  faqCheatingAnswer: {
    en: "We take fair play seriously. Any suspected cheating, manipulation, or violation of our terms will be investigated. Offenders may face disqualification from current and future competitions, loss of prizes, and permanent account suspension.",
    fr: "Nous prenons le fair-play au sérieux. Toute suspicion de tricherie, de manipulation ou de violation de nos conditions sera enquêtée. Les contrevenants peuvent faire face à une disqualification des compétitions actuelles et futures, à la perte des prix et à une suspension permanente du compte.",
    es: "Nos tomamos el juego limpio en serio. Cualquier sospecha de trampa, manipulación o violación de nuestros términos será investigada. Los infractores pueden enfrentar descalificación de competiciones actuales y futuras, pérdida de premios y suspensión permanente de la cuenta.",
    ar: "نحن نأخذ اللعب النظيف على محمل الجد. سيتم التحقيق في أي غش مشتبه به أو تلاعب أو انتهاك لشروطنا. قد يواجه المخالفون الاستبعاد من المسابقات الحالية والمستقبلية، وخسارة الجوائز، وتعليق الحساب بشكل دائم.",
    jp: "私たちはフェアプレーを真剣に受け止めています。不正行為、操作、または利用規約違反の疑いがある場合は調査されます。違反者は現在および将来の競技からの失格、賞品の剥奪、永久的なアカウント停止に直面する可能性があります。"
  },
  sessionExpired: {
    en: "Session Expired",
    fr: "Session expirée",
    es: "Sesión expirada",
    ar: "انتهت الجلسة",
    jp: "セッションが期限切れです"
  },
  sessionExpiredMessage: {
    en: "We couldn't find your user data. Please make sure JavaScript is enabled, reload the page, and log in again.",
    fr: "Nous n'avons pas pu trouver vos données utilisateur. Veuillez vous assurer que JavaScript est activé, recharger la page et vous reconnecter.",
    es: "No pudimos encontrar tus datos de usuario. Asegúrate de que JavaScript esté habilitado, recarga la página e inicia sesión de nuevo.",
    ar: "لم نتمكن من العثور على بيانات المستخدم الخاصة بك. يرجى التأكد من تمكين JavaScript، وإعادة تحميل الصفحة، وتسجيل الدخول مرة أخرى.",
    jp: "ユーザーデータが見つかりませんでした。JavaScriptが有効になっていることを確認し、ページを再読み込みして、再度ログインしてください。"
  },
  reloadPage: {
    en: "Reload Page",
    fr: "Recharger la page",
    es: "Recargar página",
    ar: "إعادة تحميل الصفحة",
    jp: "ページを再読み込み"
  },
};

/**
 * Get a translated string by key
 * @param key - Translation key
 * @param lang - Language code (defaults to 'en')
 * @returns Translated string or key if not found
 */
export function t(key: string, lang: Language = 'en'): string {
  const translation = translations[key];
  if (!translation) {
    console.warn(`Translation missing for key: ${key}`);
    return key;
  }
  return translation[lang] || translation.en || key;
}

/**
 * Check if a language code is supported
 * @param lang - Language code to check
 * @returns true if the language is supported
 */
export function isValidLanguage(lang: string): lang is Language {
  return SUPPORTED_LANGUAGES.includes(lang as Language);
}

/**
 * Parse ISO 639-1 language code to get a supported language
 * Handles: en-US, fr-*, es-*, ar-* (all Arabic variants), ja-* (Japanese)
 * @param langCode - Language string (e.g., 'en-US', 'fr-FR', 'ja-JP', 'ar-SA')
 * @returns Supported language code or default language
 */
export function parseLanguage(langCode: string): Language {
  // Get the primary language code (e.g., 'en' from 'en-US')
  const primary = langCode.split('-')[0]?.toLowerCase();
  
  // Map ISO 639-1 codes to our supported languages
  // Japanese: 'ja' (ISO 639-1) → 'jp' (our code)
  if (primary === 'ja') {
    return 'jp';
  }
  
  // Direct match for supported languages (en, fr, es, ar)
  if (primary && isValidLanguage(primary)) {
    return primary;
  }
  
  return DEFAULT_LANGUAGE;
}
